/*
 * @Description: 聊天模块国际化文案
 */
export default {
    zh: {
        // 通用操作
        edit: '编辑',
        cancel: '取消',
        confirm: '确定',
        processing: '处理中...',
        saving: '保存中...',
        save: '保存',

        // 消息操作菜单
        startNewChatFromHere: '从此处开始新聊天',

        // 心声相关
        viewHeart: '查看心声',
        heartMoment: '内心时刻',
        unlocking: '解锁中...',
        unlock: '解锁',

        // 语音引导
        voiceGuideText: '开启开关后，角色回复将自动生成语音播放。',

        // 媒体生成弹窗
        imageGeneration: '生成图片',
        videoGeneration: '生成视频',
        imageSubtitle: '基于当前对话，为您生成专属画面',
        videoSubtitle: '赋予静止的画面以生命，记录流动的时光',
        character: '角色',
        currentCharacter: '当前角色',
        uploadYourPhoto: '上传你的照片',
        optional: '(可选)',
        imageHint: '您可以上传一张自己的照片，我将根据您的外貌特征生成我们两人的合照。若不上传，我将生成一张基于当前对话的单人照发给您。',
        videoHint: '您可以上传一张自己的照片，生成与角色的双人动态视频。若不上传，将生成角色的单人演绎视频。',
        isPublic: '是否公开',
        startGenerate: '开始生成',

        // 媒体结果弹窗
        generatingImage: '图片生成中...',
        generatingVideo: '视频生成中...',
        imageGeneratingSubtitle: '照片生成需要一点时间。完成后，我会直接把照片发送到我们的聊天框中，你可以先去聊天。',
        videoGeneratingSubtitle: '视频生成需要一点时间。完成后，我会直接把视频发送到我们的聊天框中，你可以先去聊天。',
        continueChat: '继续聊天',
        imageComplete: '生成完成',
        videoComplete: '生成完成',
        imageCompleteSubtitle: '这是属于我们的回忆',
        videoCompleteSubtitle: '这是属于我们的回忆',
        saveImage: '保存照片',
        saveVideo: '保存视频',
        generateFailed: '生成失败，请稍后重试',
        gotIt: '我知道了',

        // 聊天输入
        inputPlaceholder: '你要说些什么',

        // 编辑消息弹窗
        editMessage: '编辑消息',
        editPlaceholder: '请输入消息内容',
        editHint: '提示：使用 () 来包裹角色的动作、神态或环境的描写',

        // 回溯确认弹窗
        rollbackTitle: '从此处开始新聊天',
        rollbackMessage: '从此处开始聊天后，将会删除以下的所有聊天，是否确定？',

        // 模式选择器
        switchChatMode: '切换聊天模式',
        subscribe: '订阅',
        freeUnlimitedChat: '免费畅聊',
        vipMemberBanner: '开通会员 畅想',
        unlimitedChat: '无限对话',
        vipDescription: '烈火、悠闲 双重极致体验',
        vipDescriptionSuffix: 'VIP 0金币无限聊，释放你的所有想象。',
        vipFree: 'VIP免费',
        vipOnly: '仅限VIP',
        perMessage: '/条',
        saveChanges: '保存更改',

        // 消息列表
        messageList: '消息列表',
        recent: '最近',
        recentChats: '最近聊天角色',
        loading: '加载中...',
        noRecords: '暂无聊天记录',
        emoji: '[表情]',
        image: '[图片]',
        audio: '[语音]',

        // 聊天页面空状态
        selectChatToStart: '选择一个聊天开始对话',
        selectFromList: '从左侧列表中选择或创建新的对话',
        selectChatForDetail: '选择聊天查看角色详情',

        // Toast 消息
        toast: {
            noTopics: '暂无推荐话题',
            getTopicsFailed: '获取推荐话题失败',
            noMessageToRefresh: '没有可刷新的消息',
            editSuccess: '修改成功',
            editFailed: '修改失败',
            operationSuccess: '操作成功',
            operationFailed: '操作失败',
            selectImageFile: '请选择图片文件',
            imageSizeLimit: '图片大小不能超过10MB',
            uploading: '正在上传...',
            uploadSuccess: '上传成功',
            uploadFailed: '上传失败',
            insufficientCoins: '金币不足，请先充值',
            noImageToSave: '暂无图片可保存',
            noVideoToSave: '暂无视频可保存',
            saveSuccess: '保存成功',
            saveFailed: '保存失败，请重试',
            mediaLoadFailed: '媒体加载失败',
            switchSuccess: '已切换到',
            switchFailed: '切换模式失败',
            networkError: '网络错误，请重试',
            waitForAiReply: '请等待AI回复',
            sendFailed: '发送失败，请重试',
            regenerateFailed: '重新生成失败，请重试',
            waitTimeout: '等待超时，请重试',
            audioGenerateSuccess: '语音生成成功',
            conversationNotExist: '会话不存在',
            audioGenerateFailed: '生成语音失败',
            mediaGenerating: '正在生成中...',
            imageGenerating: '图片生成中...',
            videoGenerating: '视频生成中...',
            mediaGenerateFailed: '生成失败，请重试',
            mediaNetworkError: '网络错误，请重试',
            heartUnlockSuccess: '解锁成功',
            heartUnlockFailed: '解锁失败',
        },
    },
    en: {
        // Common operations
        edit: 'Edit',
        cancel: 'Cancel',
        confirm: 'Confirm',
        processing: 'Processing...',
        saving: 'Saving...',
        save: 'Save',

        // Message action menu
        startNewChatFromHere: 'Start new chat from here',

        // Heart related
        viewHeart: 'View Heart',
        heartMoment: 'Heart Moment',
        unlocking: 'Unlocking...',
        unlock: 'Unlock',

        // Voice guide
        voiceGuideText: 'When enabled, character replies will automatically generate voice playback.',

        // Media generation modal
        imageGeneration: 'Generate Image',
        videoGeneration: 'Generate Video',
        imageSubtitle: 'Generate exclusive visuals based on the current conversation',
        videoSubtitle: 'Bring still images to life, capture flowing moments',
        character: 'Character',
        currentCharacter: 'Current Character',
        uploadYourPhoto: 'Upload your photo',
        optional: '(Optional)',
        imageHint: 'You can upload a photo of yourself, and I will generate a photo of both of us based on your appearance. If not uploaded, I will generate a solo photo based on the current conversation.',
        videoHint: 'You can upload a photo of yourself to generate a duo video with the character. If not uploaded, a solo character video will be generated.',
        isPublic: 'Make Public',
        startGenerate: 'Start Generate',

        // Media result modal
        generatingImage: 'Generating image...',
        generatingVideo: 'Generating video...',
        imageGeneratingSubtitle: 'Photo generation takes a moment. Once complete, I will send the photo directly to our chat. Feel free to continue chatting.',
        videoGeneratingSubtitle: 'Video generation takes a moment. Once complete, I will send the video directly to our chat. Feel free to continue chatting.',
        continueChat: 'Continue Chat',
        imageComplete: 'Generation Complete',
        videoComplete: 'Generation Complete',
        imageCompleteSubtitle: 'This is our exclusive memory',
        videoCompleteSubtitle: 'This is our exclusive memory',
        saveImage: 'Save Photo',
        saveVideo: 'Save Video',
        generateFailed: 'Generation failed, please try again later',
        gotIt: 'Got it',

        // Chat input
        inputPlaceholder: 'What would you like to say',

        // Edit message modal
        editMessage: 'Edit Message',
        editPlaceholder: 'Please enter message content',
        editHint: 'Tip: Use () to wrap character actions, expressions, or environment descriptions',

        // Rollback confirmation modal
        rollbackTitle: 'Start new chat from here',
        rollbackMessage: 'Starting chat from here will delete all subsequent messages. Are you sure?',

        // Mode selector
        switchChatMode: 'Switch Chat Mode',
        subscribe: 'Subscribe',
        freeUnlimitedChat: 'Free Unlimited Chat',
        vipMemberBanner: 'Become VIP and enjoy',
        unlimitedChat: 'Unlimited Chat',
        vipDescription: 'Intense & Chill dual experience',
        vipDescriptionSuffix: 'VIP 0 coins unlimited chat, unleash all your imagination.',
        vipFree: 'VIP Free',
        vipOnly: 'VIP Only',
        perMessage: '/msg',
        saveChanges: 'Save Changes',

        // Message list
        messageList: 'Messages',
        recent: 'Recent',
        recentChats: 'Recent Chats',
        loading: 'Loading...',
        noRecords: 'No chat records',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Select a chat to start',
        selectFromList: 'Select from the list or create a new conversation',
        selectChatForDetail: 'Select a chat to view character details',

        // Toast messages
        toast: {
            noTopics: 'No recommended topics available',
            getTopicsFailed: 'Failed to get recommended topics',
            noMessageToRefresh: 'No message to refresh',
            editSuccess: 'Edit successful',
            editFailed: 'Edit failed',
            operationSuccess: 'Operation successful',
            operationFailed: 'Operation failed',
            selectImageFile: 'Please select an image file',
            imageSizeLimit: 'Image size cannot exceed 10MB',
            uploading: 'Uploading...',
            uploadSuccess: 'Upload successful',
            uploadFailed: 'Upload failed',
            insufficientCoins: 'Insufficient coins, please recharge',
            noImageToSave: 'No image to save',
            noVideoToSave: 'No video to save',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed, please try again',
            mediaLoadFailed: 'Media failed to load',
            switchSuccess: 'Switched to',
            switchFailed: 'Failed to switch mode',
            networkError: 'Network error, please try again',
            waitForAiReply: 'Please wait for AI reply',
            sendFailed: 'Failed to send, please try again',
            regenerateFailed: 'Failed to regenerate, please try again',
            waitTimeout: 'Wait timeout, please try again',
            audioGenerateSuccess: 'Audio generated successfully',
            conversationNotExist: 'Conversation does not exist',
            audioGenerateFailed: 'Failed to generate audio',
            mediaGenerating: 'Generating...',
            imageGenerating: 'Generating image...',
            videoGenerating: 'Generating video...',
            mediaGenerateFailed: 'Generation failed, please try again',
            mediaNetworkError: 'Network error, please try again',
            heartUnlockSuccess: 'Unlocked successfully',
            heartUnlockFailed: 'Failed to unlock',
        },
    },
    ja: {
        // 共通操作
        edit: '編集',
        cancel: 'キャンセル',
        confirm: '確認',
        processing: '処理中...',
        saving: '保存中...',
        save: '保存',

        // メッセージ操作メニュー
        startNewChatFromHere: 'ここから新しいチャットを開始',

        // ハート関連
        viewHeart: '心の声を見る',
        heartMoment: '心の瞬間',
        unlocking: 'アンロック中...',
        unlock: 'アンロック',

        // 音声ガイド
        voiceGuideText: 'オンにすると、キャラクターの返信が自動的に音声再生されます。',

        // メディア生成モーダル
        imageGeneration: '画像生成',
        videoGeneration: '動画生成',
        imageSubtitle: '現在の会話に基づいて、あなただけの特別な画像を生成します',
        videoSubtitle: '静止画像に命を吹き込み、流れる瞬間を記録します',
        character: 'キャラクター',
        currentCharacter: '現在のキャラクター',
        uploadYourPhoto: '写真をアップロード',
        optional: '(任意)',
        imageHint: 'ご自身の写真をアップロードすると、外見の特徴に基づいて二人の写真を生成します。アップロードしない場合は、現在の会話に基づいたソロ写真を生成します。',
        videoHint: 'ご自身の写真をアップロードすると、キャラクターとのデュオ動画を生成します。アップロードしない場合は、キャラクターのソロ動画を生成します。',
        isPublic: '公開設定',
        startGenerate: '生成開始',

        // メディア結果モーダル
        generatingImage: '画像生成中...',
        generatingVideo: '動画生成中...',
        imageGeneratingSubtitle: '画像の生成には少し時間がかかります。完了したら、チャットに直接写真を送信しますので、チャットを続けてお待ちください。',
        videoGeneratingSubtitle: '動画の生成には少し時間がかかります。完了したら、チャットに動画を送信しますので、チャットを続けてお待ちください。',
        continueChat: 'チャットを続ける',
        imageComplete: '生成完了',
        videoComplete: '生成完了',
        imageCompleteSubtitle: 'これは私たちだけの思い出です',
        videoCompleteSubtitle: 'これは私たちだけの思い出です',
        saveImage: '写真を保存',
        saveVideo: '動画を保存',
        generateFailed: '生成に失敗しました。後でもう一度お試しください',
        gotIt: '了解',

        // チャット入力
        inputPlaceholder: '何を話しますか',

        // メッセージ編集モーダル
        editMessage: 'メッセージを編集',
        editPlaceholder: 'メッセージ内容を入力してください',
        editHint: 'ヒント: () を使用してキャラクターの動作、表情、または環境の説明を囲みます',

        // ロールバック確認モーダル
        rollbackTitle: 'ここから新しいチャットを開始',
        rollbackMessage: 'ここからチャットを開始すると、以降のすべてのメッセージが削除されます。よろしいですか？',

        // モード選択
        switchChatMode: 'チャットモードを切替',
        subscribe: '登録する',
        freeUnlimitedChat: '無料で無制限チャット',
        vipMemberBanner: 'VIP会員になって',
        unlimitedChat: '無制限チャット',
        vipDescription: '情熱＆リラックス二重体験',
        vipDescriptionSuffix: 'VIP 0コイン無制限チャット、すべての想像力を解放。',
        vipFree: 'VIP無料',
        vipOnly: 'VIP専用',
        perMessage: '/件',
        saveChanges: '変更を保存',

        // メッセージリスト
        messageList: 'メッセージ',
        recent: '最近',
        recentChats: '最近のチャット',
        loading: '読み込み中...',
        noRecords: 'チャット履歴がありません',
        emoji: '[スタンプ]',
        image: '[画像]',
        audio: '[音声]',

        // チャットページ空状態
        selectChatToStart: 'チャットを選択して開始',
        selectFromList: 'リストから選択または新しい会話を作成',
        selectChatForDetail: 'チャットを選択してキャラクター詳細を表示',

        // トーストメッセージ
        toast: {
            noTopics: 'おすすめのトピックがありません',
            getTopicsFailed: 'おすすめトピックの取得に失敗しました',
            noMessageToRefresh: '更新するメッセージがありません',
            editSuccess: '編集成功',
            editFailed: '編集失敗',
            operationSuccess: '操作成功',
            operationFailed: '操作失敗',
            selectImageFile: '画像ファイルを選択してください',
            imageSizeLimit: '画像サイズは10MBを超えることはできません',
            uploading: 'アップロード中...',
            uploadSuccess: 'アップロード成功',
            uploadFailed: 'アップロード失敗',
            insufficientCoins: 'コインが不足しています。チャージしてください',
            noImageToSave: '保存する画像がありません',
            noVideoToSave: '保存する動画がありません',
            saveSuccess: '保存成功',
            saveFailed: '保存に失敗しました。もう一度お試しください',
            mediaLoadFailed: 'メディアの読み込みに失敗しました',
            switchSuccess: '切り替え完了：',
            switchFailed: 'モード切替に失敗しました',
            networkError: 'ネットワークエラー、もう一度お試しください',
            waitForAiReply: 'AIの返答をお待ちください',
            sendFailed: '送信に失敗しました。もう一度お試しください',
            regenerateFailed: '再生成に失敗しました。もう一度お試しください',
            waitTimeout: '待機がタイムアウトしました。もう一度お試しください',
            audioGenerateSuccess: '音声が正常に生成されました',
            conversationNotExist: '会話が存在しません',
            audioGenerateFailed: '音声生成に失敗しました',
            mediaGenerating: '生成中...',
            imageGenerating: '画像生成中...',
            videoGenerating: '動画生成中...',
            mediaGenerateFailed: '生成に失敗しました。再試行してください',
            mediaNetworkError: 'ネットワークエラー。再試行してください',
            heartUnlockSuccess: 'ロック解除に成功しました',
            heartUnlockFailed: 'ロック解除に失敗しました',
        },
    },
    ko: {
        // 공통 작업
        edit: '편집',
        cancel: '취소',
        confirm: '확인',
        processing: '처리 중...',
        saving: '저장 중...',
        save: '저장',

        // 메시지 작업 메뉴
        startNewChatFromHere: '여기서 새 채팅 시작',

        // 하트 관련
        viewHeart: '마음의 소리 보기',
        heartMoment: '마음의 순간',
        unlocking: '잠금 해제 중...',
        unlock: '잠금 해제',

        // 음성 가이드
        voiceGuideText: '활성화하면 캐릭터 응답이 자동으로 음성 재생됩니다.',

        // 미디어 생성 모달
        imageGeneration: '이미지 생성',
        videoGeneration: '동영상 생성',
        imageSubtitle: '현재 대화를 바탕으로 당신만을 위한 전용 이미지를 생성합니다',
        videoSubtitle: '정지 이미지에 생명을 불어넣어 흐르는 순간을 기록합니다',
        character: '캐릭터',
        currentCharacter: '현재 캐릭터',
        uploadYourPhoto: '사진 업로드',
        optional: '(선택)',
        imageHint: '본인 사진을 업로드하면 외모 특징을 기반으로 두 사람의 사진을 생성합니다. 업로드하지 않으면 현재 대화를 기반으로 한 솔로 사진을 생성합니다.',
        videoHint: '본인 사진을 업로드하면 캐릭터와의 듀오 동영상을 생성합니다. 업로드하지 않으면 캐릭터 솔로 동영상을 생성합니다.',
        isPublic: '공개 여부',
        startGenerate: '생성 시작',

        // 미디어 결과 모달
        generatingImage: '이미지 생성 중...',
        generatingVideo: '동영상 생성 중...',
        imageGeneratingSubtitle: '이미지 생성에는 시간이 조금 소요됩니다. 완료되면 채팅방으로 바로 보내드리니, 계속 대화를 나누셔도 됩니다.',
        videoGeneratingSubtitle: '동영상 생성에는 시간이 조금 소요됩니다. 완료되면 채팅방으로 바로 보내드리니, 계속 대화를 나누셔도 됩니다.',
        continueChat: '채팅 계속하기',
        imageComplete: '생성 완료',
        videoComplete: '생성 완료',
        imageCompleteSubtitle: '우리 둘만의 추억입니다',
        videoCompleteSubtitle: '우리 둘만의 추억입니다',
        saveImage: '사진 저장',
        saveVideo: '동영상 저장',
        generateFailed: '생성 실패, 나중에 다시 시도해 주세요',
        gotIt: '알겠습니다',

        // 채팅 입력
        inputPlaceholder: '무엇을 말하고 싶으신가요',

        // 메시지 편집 모달
        editMessage: '메시지 편집',
        editPlaceholder: '메시지 내용을 입력하세요',
        editHint: '팁: ()를 사용하여 캐릭터의 동작, 표정 또는 환경 설명을 감싸세요',

        // 롤백 확인 모달
        rollbackTitle: '여기서 새 채팅 시작',
        rollbackMessage: '여기서 채팅을 시작하면 이후의 모든 메시지가 삭제됩니다. 확실합니까?',

        // 모드 선택
        switchChatMode: '채팅 모드 전환',
        subscribe: '구독',
        freeUnlimitedChat: '무료 무제한 채팅',
        vipMemberBanner: 'VIP 회원이 되어',
        unlimitedChat: '무제한 채팅',
        vipDescription: '열정 & 릴렉스 이중 경험',
        vipDescriptionSuffix: 'VIP 0코인 무제한 채팅, 모든 상상력을 발휘하세요.',
        vipFree: 'VIP 무료',
        vipOnly: 'VIP 전용',
        perMessage: '/건',
        saveChanges: '변경 사항 저장',

        // 메시지 목록
        messageList: '메시지',
        recent: '최근',
        recentChats: '최근 채팅',
        loading: '로딩 중...',
        noRecords: '채팅 기록 없음',
        emoji: '[이모티콘]',
        image: '[이미지]',
        audio: '[음성]',

        // 채팅 페이지 빈 상태
        selectChatToStart: '대화를 시작할 채팅 선택',
        selectFromList: '목록에서 선택하거나 새 대화 만들기',
        selectChatForDetail: '채팅을 선택하여 캐릭터 상세 보기',

        // 토스트 메시지
        toast: {
            noTopics: '추천 주제가 없습니다',
            getTopicsFailed: '추천 주제를 가져오는 데 실패했습니다',
            noMessageToRefresh: '새로 고칠 메시지가 없습니다',
            editSuccess: '편집 성공',
            editFailed: '편집 실패',
            operationSuccess: '작업 성공',
            operationFailed: '작업 실패',
            selectImageFile: '이미지 파일을 선택하세요',
            imageSizeLimit: '이미지 크기는 10MB를 초과할 수 없습니다',
            uploading: '업로드 중...',
            uploadSuccess: '업로드 성공',
            uploadFailed: '업로드 실패',
            insufficientCoins: '코인이 부족합니다. 충전해 주세요',
            noImageToSave: '저장할 이미지가 없습니다',
            noVideoToSave: '저장할 동영상이 없습니다',
            saveSuccess: '저장 성공',
            saveFailed: '저장 실패, 다시 시도해 주세요',
            mediaLoadFailed: '미디어 로드 실패',
            switchSuccess: '전환 완료:',
            switchFailed: '모드 전환 실패',
            networkError: '네트워크 오류, 다시 시도해 주세요',
            waitForAiReply: 'AI 응답을 기다려 주세요',
            sendFailed: '전송 실패, 다시 시도해 주세요',
            regenerateFailed: '재생성 실패, 다시 시도해 주세요',
            waitTimeout: '대기 시간 초과, 다시 시도해 주세요',
            audioGenerateSuccess: '음성이 성공적으로 생성되었습니다',
            conversationNotExist: '대화가 존재하지 않습니다',
            audioGenerateFailed: '음성 생성에 실패했습니다',
            mediaGenerating: '생성 중...',
            imageGenerating: '이미지 생성 중...',
            videoGenerating: '비디오 생성 중...',
            mediaGenerateFailed: '생성 실패, 다시 시도해 주세요',
            mediaNetworkError: '네트워크 오류, 다시 시도해 주세요',
            heartUnlockSuccess: '잠금 해제 성공',
            heartUnlockFailed: '잠금 해제 실패',
        },
    },
    tw: {

        // 通用操作
        edit: '编辑',
        cancel: '取消',
        confirm: '确定',
        processing: '处理中...',
        saving: '保存中...',
        save: '保存',

        // 消息操作菜单
        startNewChatFromHere: '从此处开始新聊天',

        // 心声相关
        viewHeart: '查看心声',
        heartMoment: '内心时刻',
        unlocking: '解锁中...',
        unlock: '解锁',

        // 语音引导
        voiceGuideText: '开启开关后，角色回复将自动生成语音播放。',

        // 媒体生成弹窗
        imageGeneration: '生成图片',
        videoGeneration: '生成视频',
        imageSubtitle: '基于当前对话，为您生成专属画面',
        videoSubtitle: '赋予静止的画面以生命，记录流动的时光',
        character: '角色',
        currentCharacter: '当前角色',
        uploadYourPhoto: '上传你的照片',
        optional: '(可选)',
        imageHint: '您可以上传一张自己的照片，我将根据您的外貌特征生成我们两人的合照。若不上传，我将生成一张基于当前对话的单人照发给您。',
        videoHint: '您可以上传一张自己的照片，生成与角色的双人动态视频。若不上传，将生成角色的单人演绎视频。',
        startGenerate: '开始生成',

        // 媒体结果弹窗
        generatingImage: '图片生成中...',
        generatingVideo: '视频生成中...',
        imageGeneratingSubtitle: '照片生成需要一点时间。完成后，我会直接把照片发送到我们的聊天框中，你可以先去聊天。',
        videoGeneratingSubtitle: '视频生成需要一点时间。完成后，我会直接把视频发送到我们的聊天框中，你可以先去聊天。',
        continueChat: '继续聊天',
        imageComplete: '生成完成',
        videoComplete: '生成完成',
        imageCompleteSubtitle: '这是属于我们的回忆',
        videoCompleteSubtitle: '这是属于我们的回忆',
        saveImage: '保存照片',
        saveVideo: '保存视频',
        generateFailed: '生成失败，请稍后重试',
        gotIt: '我知道了',

        // 聊天输入
        inputPlaceholder: '你要说些什么',

        // 编辑消息弹窗
        editMessage: '编辑消息',
        editPlaceholder: '请输入消息内容',
        editHint: '提示：使用 () 来包裹角色的动作、神态或环境的描写',

        // 回溯确认弹窗
        rollbackTitle: '从此处开始新聊天',
        rollbackMessage: '从此处开始聊天后，将会删除以下的所有聊天，是否确定？',

        // 模式选择器
        switchChatMode: '切换聊天模式',
        subscribe: '订阅',
        freeUnlimitedChat: '免费畅聊',
        vipMemberBanner: '开通会员 畅想',
        unlimitedChat: '无限对话',
        vipDescription: '烈火、悠闲 双重极致体验',
        vipDescriptionSuffix: 'VIP 0金币无限聊，释放你的所有想象。',
        vipFree: 'VIP免费',
        vipOnly: '仅限VIP',
        perMessage: '/条',
        saveChanges: '保存更改',

        // 消息列表
        messageList: '消息列表',
        recent: '最近',
        recentChats: '最近聊天角色',
        loading: '加载中...',
        noRecords: '暂无聊天记录',
        emoji: '[表情]',
        image: '[图片]',
        audio: '[语音]',

        // 聊天页面空状态
        selectChatToStart: '选择一个聊天开始对话',
        selectFromList: '从左侧列表中选择或创建新的对话',
        selectChatForDetail: '选择聊天查看角色详情',

        // Toast 消息
        toast: {
            noTopics: '暂无推荐话题',
            getTopicsFailed: '获取推荐话题失败',
            noMessageToRefresh: '没有可刷新的消息',
            editSuccess: '修改成功',
            editFailed: '修改失败',
            operationSuccess: '操作成功',
            operationFailed: '操作失败',
            selectImageFile: '请选择图片文件',
            imageSizeLimit: '图片大小不能超过10MB',
            uploading: '正在上传...',
            uploadSuccess: '上传成功',
            uploadFailed: '上传失败',
            insufficientCoins: '金币不足，请先充值',
            noImageToSave: '暂无图片可保存',
            noVideoToSave: '暂无视频可保存',
            saveSuccess: '保存成功',
            saveFailed: '保存失败，请重试',
            mediaLoadFailed: '媒体加载失败',
            switchSuccess: '已切换到',
            switchFailed: '切换模式失败',
            networkError: '网络错误，请重试',
            waitForAiReply: '请等待AI回复',
            sendFailed: '发送失败，请重试',
            regenerateFailed: '重新生成失败，请重试',
            waitTimeout: '等待超时，请重试',
            audioGenerateSuccess: '语音生成成功',
            conversationNotExist: '会话不存在',
            audioGenerateFailed: '生成语音失败',
            mediaGenerating: '正在生成中...',
            imageGenerating: '图片生成中...',
            videoGenerating: '视频生成中...',
            mediaGenerateFailed: '生成失败，请重试',
            mediaNetworkError: '网络错误，请重试',
            heartUnlockSuccess: '解锁成功',
            heartUnlockFailed: '解锁失败',
        },
    },
    pl: {

        // Common operations
        edit: 'Edit',
        cancel: 'Cancel',
        confirm: 'Confirm',
        processing: 'Processing...',
        saving: 'Saving...',
        save: 'Save',

        // Message action menu
        startNewChatFromHere: 'Start new chat from here',

        // Heart related
        viewHeart: 'View Heart',
        heartMoment: 'Heart Moment',
        unlocking: 'Unlocking...',
        unlock: 'Unlock',

        // Voice guide
        voiceGuideText: 'When enabled, character replies will automatically generate voice playback.',

        // Media generation modal
        imageGeneration: 'Generate Image',
        videoGeneration: 'Generate Video',
        imageSubtitle: 'Generate exclusive visuals based on the current conversation',
        videoSubtitle: 'Bring still images to life, capture flowing moments',
        character: 'Character',
        currentCharacter: 'Current Character',
        uploadYourPhoto: 'Upload your photo',
        optional: '(Optional)',
        imageHint: 'You can upload a photo of yourself, and I will generate a photo of both of us based on your appearance. If not uploaded, I will generate a solo photo based on the current conversation.',
        videoHint: 'You can upload a photo of yourself to generate a duo video with the character. If not uploaded, a solo character video will be generated.',
        startGenerate: 'Start Generate',

        // Media result modal
        generatingImage: 'Generating image...',
        generatingVideo: 'Generating video...',
        imageGeneratingSubtitle: 'Photo generation takes a moment. Once complete, I will send the photo directly to our chat. Feel free to continue chatting.',
        videoGeneratingSubtitle: 'Video generation takes a moment. Once complete, I will send the video directly to our chat. Feel free to continue chatting.',
        continueChat: 'Continue Chat',
        imageComplete: 'Generation Complete',
        videoComplete: 'Generation Complete',
        imageCompleteSubtitle: 'This is our exclusive memory',
        videoCompleteSubtitle: 'This is our exclusive memory',
        saveImage: 'Save Photo',
        saveVideo: 'Save Video',
        generateFailed: 'Generation failed, please try again later',
        gotIt: 'Got it',

        // Chat input
        inputPlaceholder: 'What would you like to say',

        // Edit message modal
        editMessage: 'Edit Message',
        editPlaceholder: 'Please enter message content',
        editHint: 'Tip: Use () to wrap character actions, expressions, or environment descriptions',

        // Rollback confirmation modal
        rollbackTitle: 'Start new chat from here',
        rollbackMessage: 'Starting chat from here will delete all subsequent messages. Are you sure?',

        // Mode selector
        switchChatMode: 'Switch Chat Mode',
        subscribe: 'Subscribe',
        freeUnlimitedChat: 'Free Unlimited Chat',
        vipMemberBanner: 'Become VIP and enjoy',
        unlimitedChat: 'Unlimited Chat',
        vipDescription: 'Intense & Chill dual experience',
        vipDescriptionSuffix: 'VIP 0 coins unlimited chat, unleash all your imagination.',
        vipFree: 'VIP Free',
        vipOnly: 'VIP Only',
        perMessage: '/msg',
        saveChanges: 'Save Changes',

        // Message list
        messageList: 'Messages',
        recent: 'Recent',
        recentChats: 'Recent Chats',
        loading: 'Loading...',
        noRecords: 'No chat records',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Select a chat to start',
        selectFromList: 'Select from the list or create a new conversation',
        selectChatForDetail: 'Select a chat to view character details',

        // Toast messages
        toast: {
            noTopics: 'No recommended topics available',
            getTopicsFailed: 'Failed to get recommended topics',
            noMessageToRefresh: 'No message to refresh',
            editSuccess: 'Edit successful',
            editFailed: 'Edit failed',
            operationSuccess: 'Operation successful',
            operationFailed: 'Operation failed',
            selectImageFile: 'Please select an image file',
            imageSizeLimit: 'Image size cannot exceed 10MB',
            uploading: 'Uploading...',
            uploadSuccess: 'Upload successful',
            uploadFailed: 'Upload failed',
            insufficientCoins: 'Insufficient coins, please recharge',
            noImageToSave: 'No image to save',
            noVideoToSave: 'No video to save',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed, please try again',
            mediaLoadFailed: 'Media failed to load',
            switchSuccess: 'Switched to',
            switchFailed: 'Failed to switch mode',
            networkError: 'Network error, please try again',
            waitForAiReply: 'Please wait for AI reply',
            sendFailed: 'Failed to send, please try again',
            regenerateFailed: 'Failed to regenerate, please try again',
            waitTimeout: 'Wait timeout, please try again',
            audioGenerateSuccess: 'Audio generated successfully',
            conversationNotExist: 'Conversation does not exist',
            audioGenerateFailed: 'Failed to generate audio',
            mediaGenerating: 'Generating...',
            imageGenerating: 'Generating image...',
            videoGenerating: 'Generating video...',
            mediaGenerateFailed: 'Generation failed, please try again',
            mediaNetworkError: 'Network error, please try again',
            heartUnlockSuccess: 'Unlocked successfully',
            heartUnlockFailed: 'Failed to unlock',
        },
    },
    es: {
        // Operaciones comunes
        edit: 'Editar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        processing: 'Procesando...',
        saving: 'Guardando...',
        save: 'Guardar',

        // Menú de acciones de mensaje
        startNewChatFromHere: 'Iniciar nuevo chat desde aquí',

        // Relacionado con corazón
        viewHeart: 'Ver corazón',
        heartMoment: 'Momento del corazón',
        unlocking: 'Desbloqueando...',
        unlock: 'Desbloquear',

        // Guía de voz
        voiceGuideText: 'Cuando está activado, las respuestas del personaje se reproducirán automáticamente con voz.',

        // Modal de generación de medios
        imageGeneration: 'Generar Imagen',
        videoGeneration: 'Generar Video',
        imageSubtitle: 'Genera visuales exclusivos basados en la conversación actual',
        videoSubtitle: 'Da vida a las imágenes estáticas, captura momentos en movimiento',
        character: 'Personaje',
        currentCharacter: 'Personaje actual',
        uploadYourPhoto: 'Sube tu foto',
        optional: '(Opcional)',
        imageHint: 'Puedes subir una foto tuya y generaré una foto de ambos basándome en tu apariencia. Si no subes una, generaré una foto individual basada en la conversación actual.',
        videoHint: 'Puedes subir una foto tuya para generar un video dúo con el personaje. Si no subes una, se generará un video individual del personaje.',
        isPublic: 'Hacer público',
        startGenerate: 'Comenzar generación',

        // Modal de resultado de medios
        generatingImage: 'Generando imagen...',
        generatingVideo: 'Generando video...',
        imageGeneratingSubtitle: 'La generación de la foto toma un momento. Una vez completada, enviaré la foto directamente a nuestro chat. Puedes seguir chateando.',
        videoGeneratingSubtitle: 'La generación del video toma un momento. Una vez completada, enviaré el video directamente a nuestro chat. Puedes seguir chateando.',
        continueChat: 'Continuar Chat',
        imageComplete: 'Generación completada',
        videoComplete: 'Generación completada',
        imageCompleteSubtitle: 'Este es nuestro recuerdo exclusivo',
        videoCompleteSubtitle: 'Este es nuestro recuerdo exclusivo',
        saveImage: 'Guardar foto',
        saveVideo: 'Guardar video',
        generateFailed: 'Generación fallida, por favor intenta de nuevo más tarde',
        gotIt: 'Entendido',

        // Entrada de chat
        inputPlaceholder: '¿Qué te gustaría decir?',

        // Modal de editar mensaje
        editMessage: 'Editar mensaje',
        editPlaceholder: 'Por favor ingresa el contenido del mensaje',
        editHint: 'Consejo: Usa () para envolver acciones del personaje, expresiones o descripciones del entorno',

        // Modal de confirmación de retroceso
        rollbackTitle: 'Iniciar nuevo chat desde aquí',
        rollbackMessage: 'Iniciar chat desde aquí eliminará todos los mensajes posteriores. ¿Estás seguro?',

        // Selector de modo
        switchChatMode: 'Cambiar modo de chat',
        subscribe: 'Suscribirse',
        freeUnlimitedChat: 'Chat Ilimitado Gratis',
        vipMemberBanner: 'Hazte VIP y disfruta',
        unlimitedChat: 'Chat ilimitado',
        vipDescription: 'Experiencia doble intensa y relajada',
        vipDescriptionSuffix: 'VIP 0 monedas chat ilimitado, libera toda tu imaginación.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Solo VIP',
        perMessage: '/msg',
        saveChanges: 'Guardar cambios',

        // Lista de mensajes
        messageList: 'Mensajes',
        recent: 'Reciente',
        recentChats: 'Chats recientes',
        loading: 'Cargando...',
        noRecords: 'Sin historial de chat',
        emoji: '[Emoji]',
        image: '[Imagen]',
        audio: '[Audio]',

        // Estado vacío de página de chat
        selectChatToStart: 'Selecciona un chat para comenzar',
        selectFromList: 'Selecciona de la lista o crea una nueva conversación',
        selectChatForDetail: 'Selecciona un chat para ver detalles del personaje',

        // Mensajes toast
        toast: {
            noTopics: 'No hay temas recomendados disponibles',
            getTopicsFailed: 'Error al obtener temas recomendados',
            noMessageToRefresh: 'No hay mensaje para actualizar',
            editSuccess: 'Edición exitosa',
            editFailed: 'Error en la edición',
            operationSuccess: 'Operación exitosa',
            operationFailed: 'Operación fallida',
            selectImageFile: 'Por favor selecciona un archivo de imagen',
            imageSizeLimit: 'El tamaño de la imagen no puede exceder 10MB',
            uploading: 'Subiendo...',
            uploadSuccess: 'Subida exitosa',
            uploadFailed: 'Subida fallida',
            insufficientCoins: 'Monedas insuficientes, por favor recarga',
            noImageToSave: 'No hay imagen para guardar',
            noVideoToSave: 'No hay video para guardar',
            saveSuccess: 'Guardado exitosamente',
            saveFailed: 'Error al guardar, por favor intenta de nuevo',
            mediaLoadFailed: 'Error al cargar el medio',
            switchSuccess: 'Cambiado a',
            switchFailed: 'Error al cambiar modo',
            networkError: 'Error de red, por favor intenta de nuevo',
            waitForAiReply: 'Por favor espera la respuesta de AI',
            sendFailed: 'Error al enviar, por favor intenta de nuevo',
            regenerateFailed: 'Error al regenerar, por favor intenta de nuevo',
            waitTimeout: 'Tiempo de espera agotado, por favor intenta de nuevo',
            audioGenerateSuccess: 'Audio generado exitosamente',
            conversationNotExist: 'La conversación no existe',
            audioGenerateFailed: 'Error al generar audio',
            mediaGenerating: 'Generando...',
            imageGenerating: 'Generando imagen...',
            videoGenerating: 'Generando video...',
            mediaGenerateFailed: 'Generación fallida, inténtalo de nuevo',
            mediaNetworkError: 'Error de red, inténtalo de nuevo',
            heartUnlockSuccess: 'Desbloqueado con éxito',
            heartUnlockFailed: 'Fallo al desbloquear',
        },
    },
    fr: {
        // Opérations communes
        edit: 'Modifier',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        processing: 'Traitement...',
        saving: 'Enregistrement...',
        save: 'Sauvegarder',

        // Menu d\'actions de message
        startNewChatFromHere: 'Démarrer une nouvelle conversation ici',

        // Lié au cœur
        viewHeart: 'Voir le cœur',
        heartMoment: 'Moment du cœur',
        unlocking: 'Déverrouillage...',
        unlock: 'Déverrouiller',

        // Guide vocal
        voiceGuideText: 'Lorsqu\'activé, les réponses du personnage seront automatiquement lues à voix haute.',

        // Modal de génération de médias
        imageGeneration: 'Générer une image',
        videoGeneration: 'Générer une vidéo',
        imageSubtitle: 'Générez des visuels exclusifs basés sur la conversation actuelle',
        videoSubtitle: 'Donnez vie aux images fixes, capturez des moments en mouvement',
        character: 'Personnage',
        currentCharacter: 'Personnage actuel',
        uploadYourPhoto: 'Téléchargez votre photo',
        optional: '(Optionnel)',
        imageHint: 'Vous pouvez télécharger une photo de vous, et je générerai une photo de nous deux basée sur votre apparence. Si non téléchargée, je générerai une photo solo basée sur la conversation actuelle.',
        videoHint: 'Vous pouvez télécharger une photo de vous pour générer une vidéo duo avec le personnage. Si non téléchargée, une vidéo solo du personnage sera générée.',
        isPublic: 'Rendre public',
        startGenerate: 'Démarrer la génération',

        // Modal de résultat de médias
        generatingImage: 'Génération de l\'image...',
        generatingVideo: 'Génération de la vidéo...',
        imageGeneratingSubtitle: 'La génération de la photo prend un moment. Une fois terminée, je l\'enverrai directement dans notre chat. Vous pouvez continuer à discuter.',
        videoGeneratingSubtitle: 'La génération de la vidéo prend un moment. Une fois terminée, je l\'enverrai directement dans notre chat. Vous pouvez continuer à discuter.',
        continueChat: 'Continuer le chat',
        imageComplete: 'Génération terminée',
        videoComplete: 'Génération terminée',
        imageCompleteSubtitle: 'C\'est notre souvenir exclusif',
        videoCompleteSubtitle: 'C\'est notre souvenir exclusif',
        saveImage: 'Enregistrer la photo',
        saveVideo: 'Enregistrer la vidéo',
        generateFailed: 'Génération échouée, veuillez réessayer plus tard',
        gotIt: 'Compris',

        // Entrée de chat
        inputPlaceholder: 'Que voulez-vous dire',

        // Modal de modification de message
        editMessage: 'Modifier le message',
        editPlaceholder: 'Veuillez entrer le contenu du message',
        editHint: 'Conseil: Utilisez () pour envelopper les actions du personnage, les expressions ou les descriptions de l\'environnement',

        // Modal de confirmation de retour
        rollbackTitle: 'Démarrer une nouvelle conversation ici',
        rollbackMessage: 'Démarrer la conversation ici supprimera tous les messages suivants. Êtes-vous sûr?',

        // Sélecteur de mode
        switchChatMode: 'Changer le mode de chat',
        subscribe: "S'abonner",
        freeUnlimitedChat: 'Chat Illimité Gratuit',
        vipMemberBanner: 'Devenez VIP et profitez',
        unlimitedChat: 'Chat illimité',
        vipDescription: 'Double expérience intense et relaxante',
        vipDescriptionSuffix: 'VIP 0 pièce chat illimité, libérez toute votre imagination.',
        vipFree: 'VIP Gratuit',
        vipOnly: 'VIP uniquement',
        perMessage: '/msg',
        saveChanges: 'Enregistrer les modifications',

        // Liste des messages
        messageList: 'Messages',
        recent: 'Récent',
        recentChats: 'Chats récents',
        loading: 'Chargement...',
        noRecords: 'Aucun historique de chat',
        emoji: '[Emoji]',
        image: '[Image]',
        audio: '[Audio]',

        // État vide de la page de chat
        selectChatToStart: 'Sélectionnez un chat pour commencer',
        selectFromList: 'Sélectionnez dans la liste ou créez une nouvelle conversation',
        selectChatForDetail: 'Sélectionnez un chat pour voir les détails du personnage',

        // Messages toast
        toast: {
            noTopics: 'Aucun sujet recommandé disponible',
            getTopicsFailed: 'Échec de récupération des sujets recommandés',
            noMessageToRefresh: 'Aucun message à actualiser',
            editSuccess: 'Modification réussie',
            editFailed: 'Échec de la modification',
            operationSuccess: 'Opération réussie',
            operationFailed: 'Opération échouée',
            selectImageFile: 'Veuillez sélectionner un fichier image',
            imageSizeLimit: 'La taille de l\'image ne peut pas dépasser 10Mo',
            uploading: 'Téléchargement...',
            uploadSuccess: 'Téléchargement réussi',
            uploadFailed: 'Échec du téléchargement',
            insufficientCoins: 'Pièces insuffisantes, veuillez recharger',
            noImageToSave: 'Aucune image à enregistrer',
            noVideoToSave: 'Aucune vidéo à enregistrer',
            saveSuccess: 'Enregistré avec succès',
            saveFailed: 'Échec de l\'enregistrement, veuillez réessayer',
            mediaLoadFailed: 'Échec du chargement du média',
            switchSuccess: 'Changé vers',
            switchFailed: 'Échec du changement de mode',
            networkError: 'Erreur réseau, veuillez réessayer',
            waitForAiReply: 'Veuillez attendre la réponse de l\'IA',
            sendFailed: 'Échec de l\'envoi, veuillez réessayer',
            regenerateFailed: 'Échec de la régénération, veuillez réessayer',
            waitTimeout: 'Délai d\'attente expiré, veuillez réessayer',
            audioGenerateSuccess: 'Audio généré avec succès',
            conversationNotExist: 'La conversation n\'existe pas',
            audioGenerateFailed: 'Échec de la génération audio',
            mediaGenerating: 'Génération en cours...',
            imageGenerating: 'Génération de l\'image...',
            videoGenerating: 'Génération de la vidéo...',
            mediaGenerateFailed: 'Échec de la génération, réessayez',
            mediaNetworkError: 'Erreur réseau, réessayez',
            heartUnlockSuccess: 'Déverrouillage réussi',
            heartUnlockFailed: 'Échec du déverrouillage',
        },
    },
    de: {
        // Gemeinsame Operationen
        edit: 'Bearbeiten',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        processing: 'Verarbeitung...',
        saving: 'Speichern...',
        save: 'Speichern',

        // Nachrichtenaktionsmenü
        startNewChatFromHere: 'Neuen Chat von hier starten',

        // Herz bezogen
        viewHeart: 'Herz anzeigen',
        heartMoment: 'Herzmoment',
        unlocking: 'Entsperren...',
        unlock: 'Entsperren',

        // Sprachführung
        voiceGuideText: 'Wenn aktiviert, werden Charakterantworten automatisch als Sprache abgespielt.',

        // Mediengenerierungs-Modal
        imageGeneration: 'Bild generieren',
        videoGeneration: 'Video generieren',
        imageSubtitle: 'Erstellen Sie exklusive Bilder basierend auf dem aktuellen Gespräch',
        videoSubtitle: 'Erwecken Sie Standbilder zum Leben, halten Sie fließende Momente fest',
        character: 'Charakter',
        currentCharacter: 'Aktueller Charakter',
        uploadYourPhoto: 'Laden Sie Ihr Foto hoch',
        optional: '(Optional)',
        imageHint: 'Sie können ein Foto von sich hochladen, und ich werde basierend auf Ihrem Aussehen ein Foto von uns beiden erstellen. Wenn nicht hochgeladen, werde ich ein Solo-Foto basierend auf dem aktuellen Gespräch erstellen.',
        videoHint: 'Sie können ein Foto von sich hochladen, um ein Duo-Video mit dem Charakter zu erstellen. Wenn nicht hochgeladen, wird ein Solo-Charakter-Video erstellt.',
        isPublic: 'Öffentlich machen',
        startGenerate: 'Generierung starten',

        // Medienergebnis-Modal
        generatingImage: 'Bild wird generiert...',
        generatingVideo: 'Video wird generiert...',
        imageGeneratingSubtitle: 'Die Bildgenerierung dauert einen Moment. Sobald sie abgeschlossen ist, sende ich das Foto direkt in unseren Chat. Sie können gerne weiter chatten.',
        videoGeneratingSubtitle: 'Die Videogenerierung dauert einen Moment. Sobald sie abgeschlossen ist, sende ich das Video direkt in unseren Chat. Sie können gerne weiter chatten.',
        continueChat: 'Chat fortsetzen',
        imageComplete: 'Generierung abgeschlossen',
        videoComplete: 'Generierung abgeschlossen',
        imageCompleteSubtitle: 'Dies ist unsere exklusive Erinnerung',
        videoCompleteSubtitle: 'Dies ist unsere exklusive Erinnerung',
        saveImage: 'Foto speichern',
        saveVideo: 'Video speichern',
        generateFailed: 'Generierung fehlgeschlagen, bitte später erneut versuchen',
        gotIt: 'Verstanden',

        // Chat-Eingabe
        inputPlaceholder: 'Was möchten Sie sagen',

        // Nachricht bearbeiten Modal
        editMessage: 'Nachricht bearbeiten',
        editPlaceholder: 'Bitte geben Sie den Nachrichteninhalt ein',
        editHint: 'Tipp: Verwenden Sie (), um Charakteraktionen, Ausdrücke oder Umgebungsbeschreibungen zu umschließen',

        // Rollback-Bestätigungs-Modal
        rollbackTitle: 'Neuen Chat von hier starten',
        rollbackMessage: 'Das Starten des Chats von hier löscht alle nachfolgenden Nachrichten. Sind Sie sicher?',

        // Modusauswahl
        switchChatMode: 'Chat-Modus wechseln',
        subscribe: 'Abonnieren',
        freeUnlimitedChat: 'Kostenloser Unbegrenzter Chat',
        vipMemberBanner: 'Werden Sie VIP und genießen Sie',
        unlimitedChat: 'Unbegrenzten Chat',
        vipDescription: 'Intensive & entspannte Doppelerfahrung',
        vipDescriptionSuffix: 'VIP 0 Münzen unbegrenzter Chat, entfesseln Sie Ihre Fantasie.',
        vipFree: 'VIP Kostenlos',
        vipOnly: 'Nur VIP',
        perMessage: '/Msg',
        saveChanges: 'Änderungen speichern',

        // Nachrichtenliste
        messageList: 'Nachrichten',
        recent: 'Kürzlich',
        recentChats: 'Kürzliche Chats',
        loading: 'Laden...',
        noRecords: 'Keine Chat-Aufzeichnungen',
        emoji: '[Emoji]',
        image: '[Bild]',
        audio: '[Audio]',

        // Chat-Seite Leerzustand
        selectChatToStart: 'Wählen Sie einen Chat zum Starten',
        selectFromList: 'Aus der Liste auswählen oder neue Unterhaltung erstellen',
        selectChatForDetail: 'Chat auswählen für Charakterdetails',

        // Toast-Nachrichten
        toast: {
            noTopics: 'Keine empfohlenen Themen verfügbar',
            getTopicsFailed: 'Empfohlene Themen konnten nicht abgerufen werden',
            noMessageToRefresh: 'Keine Nachricht zum Aktualisieren',
            editSuccess: 'Bearbeitung erfolgreich',
            editFailed: 'Bearbeitung fehlgeschlagen',
            operationSuccess: 'Operation erfolgreich',
            operationFailed: 'Operation fehlgeschlagen',
            selectImageFile: 'Bitte wählen Sie eine Bilddatei',
            imageSizeLimit: 'Bildgröße darf 10MB nicht überschreiten',
            uploading: 'Hochladen...',
            uploadSuccess: 'Upload erfolgreich',
            uploadFailed: 'Upload fehlgeschlagen',
            insufficientCoins: 'Unzureichende Münzen, bitte aufladen',
            noImageToSave: 'Kein Bild zum Speichern',
            noVideoToSave: 'Kein Video zum Speichern',
            saveSuccess: 'Erfolgreich gespeichert',
            saveFailed: 'Speichern fehlgeschlagen, bitte erneut versuchen',
            mediaLoadFailed: 'Medien konnten nicht geladen werden',
            switchSuccess: 'Gewechselt zu',
            switchFailed: 'Moduswechsel fehlgeschlagen',
            networkError: 'Netzwerkfehler, bitte erneut versuchen',
            waitForAiReply: 'Bitte warten Sie auf die AI-Antwort',
            sendFailed: 'Senden fehlgeschlagen, bitte erneut versuchen',
            regenerateFailed: 'Regenerierung fehlgeschlagen, bitte erneut versuchen',
            waitTimeout: 'Wartezeit abgelaufen, bitte erneut versuchen',
            audioGenerateSuccess: 'Audio erfolgreich generiert',
            conversationNotExist: 'Konversation existiert nicht',
            audioGenerateFailed: 'Audio-Generierung fehlgeschlagen',
            mediaGenerating: 'Wird generiert...',
            imageGenerating: 'Bild wird generiert...',
            videoGenerating: 'Video wird generiert...',
            mediaGenerateFailed: 'Generierung fehlgeschlagen, bitte erneut versuchen',
            mediaNetworkError: 'Netzwerkfehler, bitte erneut versuchen',
            heartUnlockSuccess: 'Erfolgreich entsperrt',
            heartUnlockFailed: 'Entsperren fehlgeschlagen',
        },
    },
    ru: {
        // Общие операции
        edit: 'Редактировать',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        processing: 'Обработка...',
        saving: 'Сохранение...',
        save: 'Сохранить',

        // Меню действий сообщения
        startNewChatFromHere: 'Начать новый чат отсюда',

        // Связанное с сердцем
        viewHeart: 'Посмотреть сердце',
        heartMoment: 'Момент сердца',
        unlocking: 'Разблокировка...',
        unlock: 'Разблокировать',

        // Голосовой гид
        voiceGuideText: 'При включении ответы персонажа будут автоматически воспроизводиться голосом.',

        // Модальное окно генерации медиа
        imageGeneration: 'Создать изображение',
        videoGeneration: 'Создать видео',
        imageSubtitle: 'Создание эксклюзивных изображений на основе текущего диалога',
        videoSubtitle: 'Оживите статичные изображения, запечатлейте движущиеся моменты',
        character: 'Персонаж',
        currentCharacter: 'Текущий персонаж',
        uploadYourPhoto: 'Загрузите свою фотографию',
        optional: '(Необязательно)',
        imageHint: 'Вы можете загрузить свою фотографию, и я создам фотографию нас обоих на основе вашей внешности. Если не загружено, я создам сольную фотографию на основе текущего разговора.',
        videoHint: 'Вы можете загрузить свою фотографию для создания дуэтного видео с персонажем. Если не загружено, будет создано сольное видео персонажа.',
        isPublic: 'Сделать публичным',
        startGenerate: 'Начать генерацию',

        // Модальное окно результата медиа
        generatingImage: 'Создание изображения...',
        generatingVideo: 'Создание видео...',
        imageGeneratingSubtitle: 'Создание фото займет некоторое время. Как только оно будет готово, я отправлю его прямо в чат. Можете продолжать общение.',
        videoGeneratingSubtitle: 'Создание видео займет некоторое время. Как только оно будет готово, я отправлю его прямо в чат. Можете продолжать общение.',
        continueChat: 'Продолжить чат',
        imageComplete: 'Готово',
        videoComplete: 'Готово',
        imageCompleteSubtitle: 'Это наше эксклюзивное воспоминание',
        videoCompleteSubtitle: 'Это наше эксклюзивное воспоминание',
        saveImage: 'Сохранить фото',
        saveVideo: 'Сохранить видео',
        generateFailed: 'Генерация не удалась, попробуйте позже',
        gotIt: 'Понятно',

        // Ввод чата
        inputPlaceholder: 'Что вы хотите сказать',

        // Модальное окно редактирования сообщения
        editMessage: 'Редактировать сообщение',
        editPlaceholder: 'Пожалуйста, введите содержание сообщения',
        editHint: 'Совет: Используйте () для обрамления действий персонажа, выражений или описаний окружения',

        // Модальное окно подтверждения отката
        rollbackTitle: 'Начать новый чат отсюда',
        rollbackMessage: 'Начало чата отсюда удалит все последующие сообщения. Вы уверены?',

        // Выбор режима
        switchChatMode: 'Переключить режим чата',
        subscribe: 'Подписаться',
        freeUnlimitedChat: 'Бесплатный Безлимитный Чат',
        vipMemberBanner: 'Станьте VIP и наслаждайтесь',
        unlimitedChat: 'Безлимитным чатом',
        vipDescription: 'Двойной опыт: интенсив и релакс',
        vipDescriptionSuffix: 'VIP 0 монет безлимитный чат, раскройте свое воображение.',
        vipFree: 'VIP Бесплатно',
        vipOnly: 'Только VIP',
        perMessage: '/сообщ',
        saveChanges: 'Сохранить изменения',

        // Список сообщений
        messageList: 'Сообщения',
        recent: 'Недавние',
        recentChats: 'Недавние чаты',
        loading: 'Загрузка...',
        noRecords: 'Нет истории чата',
        emoji: '[Эмодзи]',
        image: '[Изображение]',
        audio: '[Аудио]',

        // Пустое состояние страницы чата
        selectChatToStart: 'Выберите чат для начала',
        selectFromList: 'Выберите из списка или создайте новый разговор',
        selectChatForDetail: 'Выберите чат для просмотра деталей персонажа',

        // Тост-сообщения
        toast: {
            noTopics: 'Нет доступных рекомендованных тем',
            getTopicsFailed: 'Не удалось получить рекомендованные темы',
            noMessageToRefresh: 'Нет сообщения для обновления',
            editSuccess: 'Редактирование успешно',
            editFailed: 'Ошибка редактирования',
            operationSuccess: 'Операция успешна',
            operationFailed: 'Операция не удалась',
            selectImageFile: 'Пожалуйста, выберите файл изображения',
            imageSizeLimit: 'Размер изображения не может превышать 10МБ',
            uploading: 'Загрузка...',
            uploadSuccess: 'Загрузка успешна',
            uploadFailed: 'Загрузка не удалась',
            insufficientCoins: 'Недостаточно монет, пожалуйста, пополните',
            noImageToSave: 'Нет изображения для сохранения',
            noVideoToSave: 'Нет видео для сохранения',
            saveSuccess: 'Успешно сохранено',
            saveFailed: 'Сохранение не удалось, попробуйте снова',
            mediaLoadFailed: 'Не удалось загрузить медиа',
            switchSuccess: 'Переключено на',
            switchFailed: 'Не удалось переключить режим',
            networkError: 'Ошибка сети, попробуйте снова',
            waitForAiReply: 'Пожалуйста, дождитесь ответа ИИ',
            sendFailed: 'Отправка не удалась, попробуйте снова',
            regenerateFailed: 'Регенерация не удалась, попробуйте снова',
            waitTimeout: 'Время ожидания истекло, попробуйте снова',
            audioGenerateSuccess: 'Аудио успешно сгенерировано',
            conversationNotExist: 'Разговор не существует',
            audioGenerateFailed: 'Не удалось сгенерировать аудио',
            mediaGenerating: 'Генерация...',
            imageGenerating: 'Генерация изображения...',
            videoGenerating: 'Генерация видео...',
            mediaGenerateFailed: 'Ошибка генерации, попробуйте снова',
            mediaNetworkError: 'Ошибка сети, попробуйте снова',
            heartUnlockSuccess: 'Разблокировано успешно',
            heartUnlockFailed: 'Не удалось разблокировать',
        },
    },
    pt: {
        // Operações comuns
        edit: 'Editar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        processing: 'Processando...',
        saving: 'Salvando...',
        save: 'Salvar',

        // Menu de ações de mensagem
        startNewChatFromHere: 'Iniciar novo chat daqui',

        // Relacionado ao coração
        viewHeart: 'Ver coração',
        heartMoment: 'Momento do coração',
        unlocking: 'Desbloqueando...',
        unlock: 'Desbloquear',

        // Guia de voz
        voiceGuideText: 'Quando ativado, as respostas do personagem serão automaticamente reproduzidas em voz.',

        // Modal de geração de mídia
        imageGeneration: 'Gerar Imagem',
        videoGeneration: 'Gerar Vídeo',
        imageSubtitle: 'Gere visuais exclusivos com base na conversa atual',
        videoSubtitle: 'Dê vida a imagens estáticas, capture momentos em movimento',
        character: 'Personagem',
        currentCharacter: 'Personagem atual',
        uploadYourPhoto: 'Envie sua foto',
        optional: '(Opcional)',
        imageHint: 'Você pode enviar uma foto sua, e eu gerarei uma foto de nós dois com base na sua aparência. Se não enviar, gerarei uma foto solo baseada na conversa atual.',
        videoHint: 'Você pode enviar uma foto sua para gerar um vídeo duo com o personagem. Se não enviar, será gerado um vídeo solo do personagem.',
        isPublic: 'Tornar público',
        startGenerate: 'Iniciar geração',

        // Modal de resultado de mídia
        generatingImage: 'Gerando imagem...',
        generatingVideo: 'Gerando vídeo...',
        imageGeneratingSubtitle: 'A geração da foto leva um momento. Assim que estiver concluída, enviarei a foto diretamente para o nosso chat. Sinta-se à vontade para continuar conversando.',
        videoGeneratingSubtitle: 'A geração do vídeo leva um momento. Assim que estiver concluída, enviarei o vídeo diretamente para o nosso chat. Sinta-se à vontade para continuar conversando.',
        continueChat: 'Continuar Chat',
        imageComplete: 'Geração Concluída',
        videoComplete: 'Geração Concluída',
        imageCompleteSubtitle: 'Esta é a nossa memória exclusiva',
        videoCompleteSubtitle: 'Esta é a nossa memória exclusiva',
        saveImage: 'Salvar foto',
        saveVideo: 'Salvar vídeo',
        generateFailed: 'Geração falhou, por favor tente novamente mais tarde',
        gotIt: 'Entendi',

        // Entrada de chat
        inputPlaceholder: 'O que você gostaria de dizer',

        // Modal de edição de mensagem
        editMessage: 'Editar mensagem',
        editPlaceholder: 'Por favor, insira o conteúdo da mensagem',
        editHint: 'Dica: Use () para envolver ações do personagem, expressões ou descrições do ambiente',

        // Modal de confirmação de rollback
        rollbackTitle: 'Iniciar novo chat daqui',
        rollbackMessage: 'Iniciar o chat daqui excluirá todas as mensagens subsequentes. Tem certeza?',

        // Seletor de modo
        switchChatMode: 'Mudar modo de chat',
        subscribe: 'Assinar',
        freeUnlimitedChat: 'Chat Ilimitado Grátis',
        vipMemberBanner: 'Torne-se VIP e aproveite',
        unlimitedChat: 'Chat ilimitado',
        vipDescription: 'Experiência dupla intensa e relaxante',
        vipDescriptionSuffix: 'VIP 0 moedas chat ilimitado, liberte sua imaginação.',
        vipFree: 'VIP Grátis',
        vipOnly: 'Apenas VIP',
        perMessage: '/msg',
        saveChanges: 'Salvar alterações',

        // Lista de mensagens
        messageList: 'Mensagens',
        recent: 'Recente',
        recentChats: 'Chats recentes',
        loading: 'Carregando...',
        noRecords: 'Sem histórico de chat',
        emoji: '[Emoji]',
        image: '[Imagem]',
        audio: '[Áudio]',

        // Estado vazio da página de chat
        selectChatToStart: 'Selecione um chat para começar',
        selectFromList: 'Selecione da lista ou crie uma nova conversa',
        selectChatForDetail: 'Selecione um chat para ver detalhes do personagem',

        // Mensagens toast
        toast: {
            noTopics: 'Nenhum tópico recomendado disponível',
            getTopicsFailed: 'Falha ao obter tópicos recomendados',
            noMessageToRefresh: 'Nenhuma mensagem para atualizar',
            editSuccess: 'Edição bem-sucedida',
            editFailed: 'Falha na edição',
            operationSuccess: 'Operação bem-sucedida',
            operationFailed: 'Operação falhou',
            selectImageFile: 'Por favor, selecione um arquivo de imagem',
            imageSizeLimit: 'O tamanho da imagem não pode exceder 10MB',
            uploading: 'Enviando...',
            uploadSuccess: 'Envio bem-sucedido',
            uploadFailed: 'Falha no envio',
            insufficientCoins: 'Moedas insuficientes, por favor recarregue',
            noImageToSave: 'Nenhuma imagem para salvar',
            noVideoToSave: 'Nenhum vídeo para salvar',
            saveSuccess: 'Salvo com sucesso',
            saveFailed: 'Falha ao salvar, por favor tente novamente',
            mediaLoadFailed: 'Falha ao carregar mídia',
            switchSuccess: 'Alterado para',
            switchFailed: 'Falha ao mudar modo',
            networkError: 'Erro de rede, por favor tente novamente',
            waitForAiReply: 'Por favor, aguarde a resposta da IA',
            sendFailed: 'Falha ao enviar, por favor tente novamente',
            regenerateFailed: 'Falha ao regenerar, por favor tente novamente',
            waitTimeout: 'Tempo de espera esgotado, por favor tente novamente',
            audioGenerateSuccess: 'Áudio gerado com sucesso',
            conversationNotExist: 'Conversa não existe',
            audioGenerateFailed: 'Falha ao gerar áudio',
            mediaGenerating: 'Gerando...',
            imageGenerating: 'Gerando imagem...',
            videoGenerating: 'Gerando vídeo...',
            mediaGenerateFailed: 'Falha na geração, tente novamente',
            mediaNetworkError: 'Erro de rede, tente novamente',
            heartUnlockSuccess: 'Desbloqueado com sucesso',
            heartUnlockFailed: 'Falha ao desbloquear',
        },
    },
    it: {
        // Operazioni comuni
        edit: 'Modifica',
        cancel: 'Annulla',
        confirm: 'Conferma',
        processing: 'Elaborazione...',
        saving: 'Salvataggio...',
        save: 'Salva',

        // Menu azioni messaggio
        startNewChatFromHere: 'Inizia nuova chat da qui',

        // Relativo al cuore
        viewHeart: 'Vedi cuore',
        heartMoment: 'Momento del cuore',
        unlocking: 'Sblocco in corso...',
        unlock: 'Sblocca',

        // Guida vocale
        voiceGuideText: 'Quando abilitato, le risposte del personaggio verranno riprodotte automaticamente con voce.',

        // Modal generazione media
        imageGeneration: 'Genera Immagine',
        videoGeneration: 'Genera Video',
        imageSubtitle: 'Genera visual esclusivi basati sulla conversazione attuale',
        videoSubtitle: 'Dai vita alle immagini statiche, cattura momenti in movimento',
        character: 'Personaggio',
        currentCharacter: 'Personaggio attuale',
        uploadYourPhoto: 'Carica la tua foto',
        optional: '(Opzionale)',
        imageHint: 'Puoi caricare una tua foto e genererò una foto di entrambi basata sul tuo aspetto. Se non caricata, genererò una foto singola basata sulla conversazione attuale.',
        videoHint: 'Puoi caricare una tua foto per generare un video duo con il personaggio. Se non caricata, verrà generato un video singolo del personaggio.',
        isPublic: 'Rendi pubblico',
        startGenerate: 'Avvia generazione',

        // Modal risultato media
        generatingImage: 'Generazione immagine...',
        generatingVideo: 'Generazione video...',
        imageGeneratingSubtitle: 'La generazione della foto richiede un momento. Una volta completata, la invierò direttamente nella nostra chat. Puoi continuare a chattare.',
        videoGeneratingSubtitle: 'La generazione del video richiede un momento. Una volta completata, lo invierò direttamente nella nostra chat. Puoi continuare a chattare.',
        continueChat: 'Continua Chat',
        imageComplete: 'Generazione Completata',
        videoComplete: 'Generazione Completata',
        imageCompleteSubtitle: 'Questo è il nostro ricordo esclusivo',
        videoCompleteSubtitle: 'Questo è il nostro ricordo esclusivo',
        saveImage: 'Salva foto',
        saveVideo: 'Salva video',
        generateFailed: 'Generazione fallita, riprova più tardi',
        gotIt: 'Capito',

        // Input chat
        inputPlaceholder: 'Cosa vorresti dire',

        // Modal modifica messaggio
        editMessage: 'Modifica messaggio',
        editPlaceholder: 'Inserisci il contenuto del messaggio',
        editHint: 'Suggerimento: Usa () per racchiudere azioni del personaggio, espressioni o descrizioni dell\'ambiente',

        // Modal conferma rollback
        rollbackTitle: 'Inizia nuova chat da qui',
        rollbackMessage: 'Iniziando la chat da qui verranno eliminati tutti i messaggi successivi. Sei sicuro?',

        // Selettore modalità
        switchChatMode: 'Cambia modalità chat',
        subscribe: 'Iscriviti',
        freeUnlimitedChat: 'Chat Illimitata Gratuita',
        vipMemberBanner: 'Diventa VIP e goditi',
        unlimitedChat: 'Chat illimitata',
        vipDescription: 'Doppia esperienza intensa e rilassante',
        vipDescriptionSuffix: 'VIP 0 monete chat illimitata, libera la tua immaginazione.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Solo VIP',
        perMessage: '/msg',
        saveChanges: 'Salva modifiche',

        // Lista messaggi
        messageList: 'Messaggi',
        recent: 'Recenti',
        recentChats: 'Chat recenti',
        loading: 'Caricamento...',
        noRecords: 'Nessuna cronologia chat',
        emoji: '[Emoji]',
        image: '[Immagine]',
        audio: '[Audio]',

        // Stato vuoto pagina chat
        selectChatToStart: 'Seleziona una chat per iniziare',
        selectFromList: 'Seleziona dalla lista o crea una nuova conversazione',
        selectChatForDetail: 'Seleziona una chat per vedere i dettagli del personaggio',

        // Messaggi toast
        toast: {
            noTopics: 'Nessun argomento consigliato disponibile',
            getTopicsFailed: 'Impossibile ottenere argomenti consigliati',
            noMessageToRefresh: 'Nessun messaggio da aggiornare',
            editSuccess: 'Modifica riuscita',
            editFailed: 'Modifica fallita',
            operationSuccess: 'Operazione riuscita',
            operationFailed: 'Operazione fallita',
            selectImageFile: 'Seleziona un file immagine',
            imageSizeLimit: 'La dimensione dell\'immagine non può superare 10MB',
            uploading: 'Caricamento...',
            uploadSuccess: 'Caricamento riuscito',
            uploadFailed: 'Caricamento fallito',
            insufficientCoins: 'Monete insufficienti, ricarica',
            noImageToSave: 'Nessuna immagine da salvare',
            noVideoToSave: 'Nessun video da salvare',
            saveSuccess: 'Salvato con successo',
            saveFailed: 'Salvataggio fallito, riprova',
            mediaLoadFailed: 'Caricamento media fallito',
            switchSuccess: 'Cambiato a',
            switchFailed: 'Cambio modalità fallito',
            networkError: 'Errore di rete, riprova',
            waitForAiReply: 'Attendere la risposta dell\'IA',
            sendFailed: 'Invio fallito, riprova',
            regenerateFailed: 'Rigenerazione fallita, riprova',
            waitTimeout: 'Tempo di attesa scaduto, riprova',
            audioGenerateSuccess: 'Audio generato con successo',
            conversationNotExist: 'La conversazione non esiste',
            audioGenerateFailed: 'Generazione audio fallita',
            mediaGenerating: 'Generazione in corso...',
            imageGenerating: 'Generazione immagine...',
            videoGenerating: 'Generazione video...',
            mediaGenerateFailed: 'Generazione fallita, riprova',
            mediaNetworkError: 'Errore di rete, riprova',
            heartUnlockSuccess: 'Sbloccato con successo',
            heartUnlockFailed: 'Sblocco fallito',
        },
    },
    ar: {
        // العمليات الشائعة
        edit: 'تعديل',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        processing: 'جاري المعالجة...',
        saving: 'جاري الحفظ...',
        save: 'حفظ',

        // قائمة إجراءات الرسالة
        startNewChatFromHere: 'بدء محادثة جديدة من هنا',

        // متعلق بالقلب
        viewHeart: 'عرض القلب',
        heartMoment: 'لحظة القلب',
        unlocking: 'جاري فتح القفل...',
        unlock: 'فتح القفل',

        // دليل الصوت
        voiceGuideText: 'عند التفعيل، سيتم تشغيل ردود الشخصية تلقائياً بالصوت.',

        // نافذة إنشاء الوسائط
        imageGeneration: 'إنشاء صورة',
        videoGeneration: 'إنشاء فيديو',
        imageSubtitle: 'أنشئ صورًا حصرية بناءً على المحادثة الحالية',
        videoSubtitle: 'إحياء الصور الثابتة، التقاط لحظات متحركة',
        character: 'شخصية',
        currentCharacter: 'الشخصية الحالية',
        uploadYourPhoto: 'ارفع صورتك',
        optional: '(اختياري)',
        imageHint: 'يمكنك رفع صورة لك، وسأنشئ صورة لكلانا بناءً على مظهرك. إذا لم يتم الرفع، سأنشئ صورة فردية بناءً على المحادثة الحالية.',
        videoHint: 'يمكنك رفع صورة لك لإنشاء فيديو ثنائي مع الشخصية. إذا لم يتم الرفع، سيتم إنشاء فيديو فردي للشخصية.',
        isPublic: 'جعله عاماً',
        startGenerate: 'بدء الإنشاء',

        // نافذة نتيجة الوسائط
        generatingImage: 'جاري إنشاء الصورة...',
        generatingVideo: 'جاري إنشاء الفيديو...',
        imageGeneratingSubtitle: 'يستغرق إنشاء الصورة بعض الوقت. بمجرد الانتهاء، سأرسل الصورة مباشرة إلى محادثتنا. يمكنك متابعة الدردشة.',
        videoGeneratingSubtitle: 'يستغرق إنشاء الفيديو بعض الوقت. بمجرد الانتهاء، سأرسل الفيديو مباشرة إلى محادثتنا. يمكنك متابعة الدردشة.',
        continueChat: 'متابعة الدردشة',
        imageComplete: 'اكتمل الإنشاء',
        videoComplete: 'اكتمل الإنشاء',
        imageCompleteSubtitle: 'هذه ذكرى حصرية لنا',
        videoCompleteSubtitle: 'هذه ذكرى حصرية لنا',
        saveImage: 'حفظ الصورة',
        saveVideo: 'حفظ الفيديو',
        generateFailed: 'فشل الإنشاء، يرجى المحاولة مرة أخرى لاحقاً',
        gotIt: 'فهمت',

        // إدخال المحادثة
        inputPlaceholder: 'ماذا تريد أن تقول',

        // نافذة تعديل الرسالة
        editMessage: 'تعديل الرسالة',
        editPlaceholder: 'يرجى إدخال محتوى الرسالة',
        editHint: 'نصيحة: استخدم () لتغليف أفعال الشخصية أو تعبيراتها أو أوصاف البيئة',

        // نافذة تأكيد التراجع
        rollbackTitle: 'بدء محادثة جديدة من هنا',
        rollbackMessage: 'سيؤدي بدء المحادثة من هنا إلى حذف جميع الرسائل اللاحقة. هل أنت متأكد؟',

        // محدد الوضع
        switchChatMode: 'تغيير وضع المحادثة',
        subscribe: 'اشترك',
        freeUnlimitedChat: 'دردشة غير محدودة مجانية',
        vipMemberBanner: 'كن VIP واستمتع',
        unlimitedChat: 'بمحادثة غير محدودة',
        vipDescription: 'تجربة مزدوجة مكثفة ومريحة',
        vipDescriptionSuffix: 'VIP 0 عملة محادثة غير محدودة، أطلق العنان لخيالك.',
        vipFree: 'VIP مجاني',
        vipOnly: 'VIP فقط',
        perMessage: '/رسالة',
        saveChanges: 'حفظ التغييرات',

        // قائمة الرسائل
        messageList: 'الرسائل',
        recent: 'الأخيرة',
        recentChats: 'المحادثات الأخيرة',
        loading: 'جاري التحميل...',
        noRecords: 'لا يوجد سجل محادثات',
        emoji: '[إيموجي]',
        image: '[صورة]',
        audio: '[صوت]',

        // حالة صفحة المحادثة الفارغة
        selectChatToStart: 'اختر محادثة للبدء',
        selectFromList: 'اختر من القائمة أو أنشئ محادثة جديدة',
        selectChatForDetail: 'اختر محادثة لعرض تفاصيل الشخصية',

        // رسائل التنبيه
        toast: {
            noTopics: 'لا توجد مواضيع مقترحة متاحة',
            getTopicsFailed: 'فشل في الحصول على المواضيع المقترحة',
            noMessageToRefresh: 'لا توجد رسالة للتحديث',
            editSuccess: 'تم التعديل بنجاح',
            editFailed: 'فشل التعديل',
            operationSuccess: 'تمت العملية بنجاح',
            operationFailed: 'فشلت العملية',
            selectImageFile: 'يرجى اختيار ملف صورة',
            imageSizeLimit: 'لا يمكن أن يتجاوز حجم الصورة 10 ميجابايت',
            uploading: 'جاري الرفع...',
            uploadSuccess: 'تم الرفع بنجاح',
            uploadFailed: 'فشل الرفع',
            insufficientCoins: 'العملات غير كافية، يرجى الشحن',
            noImageToSave: 'لا توجد صورة للحفظ',
            noVideoToSave: 'لا يوجد فيديو للحفظ',
            saveSuccess: 'تم الحفظ بنجاح',
            saveFailed: 'فشل الحفظ، يرجى المحاولة مرة أخرى',
            mediaLoadFailed: 'فشل تحميل الوسائط',
            switchSuccess: 'تم التغيير إلى',
            switchFailed: 'فشل تغيير الوضع',
            networkError: 'خطأ في الشبكة، يرجى المحاولة مرة أخرى',
            waitForAiReply: 'يرجى انتظار رد الذكاء الاصطناعي',
            sendFailed: 'فشل الإرسال، يرجى المحاولة مرة أخرى',
            regenerateFailed: 'فشل إعادة التوليد، يرجى المحاولة مرة أخرى',
            waitTimeout: 'انتهت مهلة الانتظار، يرجى المحاولة مرة أخرى',
            audioGenerateSuccess: 'تم إنشاء الصوت بنجاح',
            conversationNotExist: 'المحادثة غير موجودة',
            audioGenerateFailed: 'فشل إنشاء الصوت',
            mediaGenerating: 'جاري الإنشاء...',
            imageGenerating: 'جاري إنشاء الصورة...',
            videoGenerating: 'جاري إنشاء الفيديو...',
            mediaGenerateFailed: 'فشل الإنشاء، حاول مرة أخرى',
            mediaNetworkError: 'خطأ في الشبكة، حاول مرة أخرى',
            heartUnlockSuccess: 'تم إلغاء القفل بنجاح',
            heartUnlockFailed: 'فشل إلغاء القفل',
        },
    },
    th: {
        // Common operations
        edit: 'แก้ไข',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        processing: 'กำลังประมวลผล...',
        saving: 'กำลังบันทึก...',
        save: 'บันทึก',

        // Message action menu
        startNewChatFromHere: 'เริ่มแชทใหม่จากตรงนี้',

        // Heart related
        viewHeart: 'ดูหัวใจ',
        heartMoment: 'ช่วงเวลาหัวใจ',
        unlocking: 'กำลังปลดล็อก...',
        unlock: 'ปลดล็อก',

        // Voice guide
        voiceGuideText: 'เมื่อเปิดใช้งาน การตอบกลับของตัวละครจะสร้างเสียงอัตโนมัติ',

        // Media generation modal
        imageGeneration: 'สร้างรูปภาพ',
        videoGeneration: 'สร้างวิดีโอ',
        imageSubtitle: 'สร้างภาพพิเศษจากบทสนทนาปัจจุบัน',
        videoSubtitle: 'ทำให้ภาพนิ่งมีชีวิต จับช่วงเวลาที่ไหลลื่น',
        character: 'ตัวละคร',
        currentCharacter: 'ตัวละครปัจจุบัน',
        uploadYourPhoto: 'อัปโหลดรูปของคุณ',
        optional: '(ไม่บังคับ)',
        imageHint: 'คุณสามารถอัปโหลดรูปของตัวเอง แล้วฉันจะสร้างรูปของเราทั้งคู่ตามรูปลักษณ์ของคุณ หากไม่อัปโหลด ฉันจะสร้างรูปเดี่ยวจากบทสนทนาปัจจุบัน',
        videoHint: 'คุณสามารถอัปโหลดรูปของตัวเองเพื่อสร้างวิดีโอคู่กับตัวละคร หากไม่อัปโหลด จะสร้างวิดีโอเดี่ยวของตัวละคร',
        startGenerate: 'เริ่มสร้าง',

        // Media result modal
        generatingImage: 'กำลังสร้างรูปภาพ...',
        generatingVideo: 'กำลังสร้างวิดีโอ...',
        imageGeneratingSubtitle: 'การสร้างรูปภาพใช้เวลาสักครู่ เมื่อเสร็จแล้วฉันจะส่งรูปไปยังแชท สามารถคุยต่อได้เลย',
        videoGeneratingSubtitle: 'การสร้างวิดีโอใช้เวลาสักครู่ เมื่อเสร็จแล้วฉันจะส่งวิดีโอไปยังแชท สามารถคุยต่อได้เลย',
        continueChat: 'คุยต่อ',
        imageComplete: 'สร้างเสร็จแล้ว',
        videoComplete: 'สร้างเสร็จแล้ว',
        imageCompleteSubtitle: 'นี่คือความทรงจำพิเศษของเรา',
        videoCompleteSubtitle: 'นี่คือความทรงจำพิเศษของเรา',
        saveImage: 'บันทึกรูปภาพ',
        saveVideo: 'บันทึกวิดีโอ',
        generateFailed: 'สร้างไม่สำเร็จ โปรดลองอีกครั้งภายหลัง',
        gotIt: 'เข้าใจแล้ว',

        // Chat input
        inputPlaceholder: 'คุณอยากพูดว่าอะไร',

        // Edit message modal
        editMessage: 'แก้ไขข้อความ',
        editPlaceholder: 'กรุณากรอกเนื้อหาข้อความ',
        editHint: 'เคล็ดลับ: ใช้ () ครอบการกระทำ สีหน้า หรือคำบรรยายสภาพแวดล้อม',

        // Rollback confirmation modal
        rollbackTitle: 'เริ่มแชทใหม่จากตรงนี้',
        rollbackMessage: 'การเริ่มแชทจากตรงนี้จะลบข้อความถัดไปทั้งหมด แน่ใจหรือไม่?',

        // Mode selector
        switchChatMode: 'สลับโหมดแชท',
        subscribe: 'สมัครสมาชิก',
        freeUnlimitedChat: 'แชทไม่จำกัดฟรี',
        vipMemberBanner: 'เป็น VIP แล้วรับสิทธิ์',
        unlimitedChat: 'แชทไม่จำกัด',
        vipDescription: 'ประสบการณ์สองโหมด เข้มข้น & ชิล',
        vipDescriptionSuffix: 'VIP 0 เหรียญแชทไม่จำกัด ปลดปล่อยจินตนาการของคุณ',
        vipFree: 'VIP ฟรี',
        vipOnly: 'เฉพาะ VIP',
        perMessage: '/ข้อความ',
        saveChanges: 'บันทึกการเปลี่ยนแปลง',

        // Message list
        messageList: 'ข้อความ',
        recent: 'ล่าสุด',
        recentChats: 'แชทล่าสุด',
        loading: 'กำลังโหลด...',
        noRecords: 'ไม่มีประวัติแชท',
        emoji: '[อีโมจิ]',
        image: '[รูปภาพ]',
        audio: '[เสียง]',

        // Chat page empty state
        selectChatToStart: 'เลือกแชทเพื่อเริ่ม',
        selectFromList: 'เลือกจากรายการหรือสร้างบทสนทนาใหม่',
        selectChatForDetail: 'เลือกแชทเพื่อดูรายละเอียดตัวละคร',

        // Toast messages
        toast: {
            noTopics: 'ไม่มีหัวข้อแนะนำ',
            getTopicsFailed: 'ดึงหัวข้อแนะนำล้มเหลว',
            noMessageToRefresh: 'ไม่มีข้อความให้รีเฟรช',
            editSuccess: 'แก้ไขสำเร็จ',
            editFailed: 'แก้ไขล้มเหลว',
            operationSuccess: 'ดำเนินการสำเร็จ',
            operationFailed: 'ดำเนินการล้มเหลว',
            selectImageFile: 'โปรดเลือกไฟล์รูปภาพ',
            imageSizeLimit: 'ขนาดรูปภาพต้องไม่เกิน 10MB',
            uploading: 'กำลังอัปโหลด...',
            uploadSuccess: 'อัปโหลดสำเร็จ',
            uploadFailed: 'อัปโหลดล้มเหลว',
            insufficientCoins: 'เหรียญไม่พอ โปรดเติมเงิน',
            noImageToSave: 'ไม่มีรูปภาพให้บันทึก',
            noVideoToSave: 'ไม่มีวิดีโอให้บันทึก',
            saveSuccess: 'บันทึกสำเร็จ',
            saveFailed: 'บันทึกล้มเหลว โปรดลองอีกครั้ง',
            mediaLoadFailed: 'โหลดสื่อไม่สำเร็จ',
            switchSuccess: 'สลับเป็น',
            switchFailed: 'สลับโหมดไม่สำเร็จ',
            networkError: 'เกิดข้อผิดพลาดเครือข่าย โปรดลองอีกครั้ง',
            waitForAiReply: 'โปรดรอการตอบจาก AI',
            sendFailed: 'ส่งไม่สำเร็จ โปรดลองอีกครั้ง',
            regenerateFailed: 'สร้างใหม่ไม่สำเร็จ โปรดลองอีกครั้ง',
            waitTimeout: 'หมดเวลารอ โปรดลองอีกครั้ง',
            audioGenerateSuccess: 'สร้างเสียงสำเร็จ',
            conversationNotExist: 'ไม่พบการสนทนา',
            audioGenerateFailed: 'สร้างเสียงไม่สำเร็จ',
            mediaGenerating: 'กำลังสร้าง...',
            imageGenerating: 'กำลังสร้างรูปภาพ...',
            videoGenerating: 'กำลังสร้างวิดีโอ...',
            mediaGenerateFailed: 'สร้างไม่สำเร็จ โปรดลองอีกครั้ง',
            mediaNetworkError: 'เครือข่ายผิดพลาด โปรดลองอีกครั้ง',
            heartUnlockSuccess: 'ปลดล็อกสำเร็จ',
            heartUnlockFailed: 'ปลดล็อกไม่สำเร็จ',
            },
    },
    da: {
        // Common operations
        edit: 'Rediger',
        cancel: 'Annuller',
        confirm: 'Bekræft',
        processing: 'Behandler...',
        saving: 'Gemmer...',
        save: 'Gem',

        // Message action menu
        startNewChatFromHere: 'Start ny chat herfra',

        // Heart related
        viewHeart: 'Se hjerte',
        heartMoment: 'Hjerteøjeblik',
        unlocking: 'Låser op...',
        unlock: 'Lås op',

        // Voice guide
        voiceGuideText: 'Når den er aktiveret, afspilles karakterens svar automatisk som tale.',

        // Media generation modal
        imageGeneration: 'Generér billede',
        videoGeneration: 'Generér video',
        imageSubtitle: 'Generér eksklusive billeder baseret på den aktuelle samtale',
        videoSubtitle: 'Giv stillbilleder liv, fang flydende øjeblikke',
        character: 'Karakter',
        currentCharacter: 'Nuværende karakter',
        uploadYourPhoto: 'Upload dit foto',
        optional: '(Valgfrit)',
        imageHint: 'Du kan uploade et foto af dig selv, og jeg genererer et foto af os begge baseret på dit udseende. Hvis du ikke uploader, genererer jeg et solofoto baseret på den aktuelle samtale.',
        videoHint: 'Du kan uploade et foto af dig selv for at generere en duo-video med karakteren. Hvis du ikke uploader, genereres en solo-video af karakteren.',
        startGenerate: 'Start generering',

        // Media result modal
        generatingImage: 'Genererer billede...',
        generatingVideo: 'Genererer video...',
        imageGeneratingSubtitle: 'Fotogenerering tager et øjeblik. Når det er færdigt, sender jeg billedet direkte til chatten. Du kan fortsætte med at chatte.',
        videoGeneratingSubtitle: 'Videogenerering tager et øjeblik. Når det er færdigt, sender jeg videoen direkte til chatten. Du kan fortsætte med at chatte.',
        continueChat: 'Fortsæt chat',
        imageComplete: 'Generering fuldført',
        videoComplete: 'Generering fuldført',
        imageCompleteSubtitle: 'Dette er vores eksklusive minde',
        videoCompleteSubtitle: 'Dette er vores eksklusive minde',
        saveImage: 'Gem foto',
        saveVideo: 'Gem video',
        generateFailed: 'Generering mislykkedes, prøv igen senere',
        gotIt: 'Forstået',

        // Chat input
        inputPlaceholder: 'Hvad vil du gerne sige',

        // Edit message modal
        editMessage: 'Rediger besked',
        editPlaceholder: 'Indtast beskedindhold',
        editHint: 'Tip: Brug () til at omslutte karakterhandlinger, udtryk eller miljøbeskrivelser',

        // Rollback confirmation modal
        rollbackTitle: 'Start ny chat herfra',
        rollbackMessage: 'At starte chatten herfra vil slette alle efterfølgende beskeder. Er du sikker?',

        // Mode selector
        switchChatMode: 'Skift chattilstand',
        subscribe: 'Abonnér',
        freeUnlimitedChat: 'Gratis ubegrænset chat',
        vipMemberBanner: 'Bliv VIP og nyd',
        unlimitedChat: 'Ubegrænset chat',
        vipDescription: 'Intens & chill dobbeltoplevelse',
        vipDescriptionSuffix: 'VIP 0 mønter ubegrænset chat, slip fantasien løs.',
        vipFree: 'VIP gratis',
        vipOnly: 'Kun VIP',
        perMessage: '/besked',
        saveChanges: 'Gem ændringer',

        // Message list
        messageList: 'Beskeder',
        recent: 'Seneste',
        recentChats: 'Seneste chats',
        loading: 'Indlæser...',
        noRecords: 'Ingen chatoptegnelser',
        emoji: '[Emoji]',
        image: '[Billede]',
        audio: '[Lyd]',

        // Chat page empty state
        selectChatToStart: 'Vælg en chat for at starte',
        selectFromList: 'Vælg fra listen eller opret en ny samtale',
        selectChatForDetail: 'Vælg en chat for at se karakterdetaljer',

        // Toast messages
        toast: {
            noTopics: 'Ingen anbefalede emner tilgængelige',
            getTopicsFailed: 'Kunne ikke hente anbefalede emner',
            noMessageToRefresh: 'Ingen besked at opdatere',
            editSuccess: 'Redigering lykkedes',
            editFailed: 'Redigering mislykkedes',
            operationSuccess: 'Handlingen lykkedes',
            operationFailed: 'Handlingen mislykkedes',
            selectImageFile: 'Vælg venligst en billedfil',
            imageSizeLimit: 'Billedstørrelsen må ikke overstige 10MB',
            uploading: 'Uploader...',
            uploadSuccess: 'Upload lykkedes',
            uploadFailed: 'Upload mislykkedes',
            insufficientCoins: 'Utilstrækkelige mønter, genoplad venligst',
            noImageToSave: 'Intet billede at gemme',
            noVideoToSave: 'Ingen video at gemme',
            saveSuccess: 'Gemt',
            saveFailed: 'Gem mislykkedes, prøv igen',
            mediaLoadFailed: 'Medie kunne ikke indlæses',
            switchSuccess: 'Skiftet til',
            switchFailed: 'Skift af tilstand mislykkedes',
            networkError: 'Netværksfejl, prøv igen',
            waitForAiReply: 'Vent på AI-svar',
            sendFailed: 'Afsendelse mislykkedes, prøv igen',
            regenerateFailed: 'Kunne ikke regenerere, prøv igen',
            waitTimeout: 'Ventetid udløb, prøv igen',
            audioGenerateSuccess: 'Lyd genereret',
            conversationNotExist: 'Samtalen findes ikke',
            audioGenerateFailed: 'Kunne ikke generere lyd',
            mediaGenerating: 'Genererer...',
            imageGenerating: 'Genererer billede...',
            videoGenerating: 'Genererer video...',
            mediaGenerateFailed: 'Generering mislykkedes, prøv igen',
            mediaNetworkError: 'Netværksfejl, prøv igen',
            heartUnlockSuccess: 'Låst op',
            heartUnlockFailed: 'Kunne ikke låse op',
            },
    },
    no: {
        // Common operations
        edit: 'Rediger',
        cancel: 'Avbryt',
        confirm: 'Bekreft',
        processing: 'Behandler...',
        saving: 'Lagrer...',
        save: 'Lagre',

        // Message action menu
        startNewChatFromHere: 'Start ny chat herfra',

        // Heart related
        viewHeart: 'Se hjerte',
        heartMoment: 'Hjerteøyeblikk',
        unlocking: 'Låser opp...',
        unlock: 'Lås opp',

        // Voice guide
        voiceGuideText: 'Når aktivert vil karakterens svar automatisk generere taleavspilling.',

        // Media generation modal
        imageGeneration: 'Generer bilde',
        videoGeneration: 'Generer video',
        imageSubtitle: 'Generer eksklusive bilder basert på den aktuelle samtalen',
        videoSubtitle: 'Gi stillbilder liv, fang flytende øyeblikk',
        character: 'Karakter',
        currentCharacter: 'Nåværende karakter',
        uploadYourPhoto: 'Last opp bildet ditt',
        optional: '(Valgfritt)',
        imageHint: 'Du kan laste opp et bilde av deg selv, og jeg genererer et bilde av oss begge basert på utseendet ditt. Hvis du ikke laster opp, genererer jeg et solobilde basert på den aktuelle samtalen.',
        videoHint: 'Du kan laste opp et bilde av deg selv for å generere en duo-video med karakteren. Hvis du ikke laster opp, genereres en solo-karaktervideo.',
        startGenerate: 'Start generering',

        // Media result modal
        generatingImage: 'Genererer bilde...',
        generatingVideo: 'Genererer video...',
        imageGeneratingSubtitle: 'Bildegenerering tar et øyeblikk. Når det er ferdig, sender jeg bildet direkte til chatten. Fortsett gjerne å chatte.',
        videoGeneratingSubtitle: 'Videogenerering tar et øyeblikk. Når det er ferdig, sender jeg videoen direkte til chatten. Fortsett gjerne å chatte.',
        continueChat: 'Fortsett chat',
        imageComplete: 'Generering fullført',
        videoComplete: 'Generering fullført',
        imageCompleteSubtitle: 'Dette er vårt eksklusive minne',
        videoCompleteSubtitle: 'Dette er vårt eksklusive minne',
        saveImage: 'Lagre bilde',
        saveVideo: 'Lagre video',
        generateFailed: 'Generering mislyktes, prøv igjen senere',
        gotIt: 'Skjønner',

        // Chat input
        inputPlaceholder: 'Hva vil du si',

        // Edit message modal
        editMessage: 'Rediger melding',
        editPlaceholder: 'Skriv inn meldingsinnhold',
        editHint: 'Tips: Bruk () for å omslutte karakterhandlinger, uttrykk eller miljøbeskrivelser',

        // Rollback confirmation modal
        rollbackTitle: 'Start ny chat herfra',
        rollbackMessage: 'Å starte chatten herfra vil slette alle etterfølgende meldinger. Er du sikker?',

        // Mode selector
        switchChatMode: 'Bytt chatmodus',
        subscribe: 'Abonner',
        freeUnlimitedChat: 'Gratis ubegrenset chat',
        vipMemberBanner: 'Bli VIP og få',
        unlimitedChat: 'Ubegrenset chat',
        vipDescription: 'Intens & chill dobbel opplevelse',
        vipDescriptionSuffix: 'VIP 0 mynter ubegrenset chat, slipp løs fantasien.',
        vipFree: 'VIP gratis',
        vipOnly: 'Kun VIP',
        perMessage: '/melding',
        saveChanges: 'Lagre endringer',

        // Message list
        messageList: 'Meldinger',
        recent: 'Nylig',
        recentChats: 'Nylige chatter',
        loading: 'Laster...',
        noRecords: 'Ingen chatlogg',
        emoji: '[Emoji]',
        image: '[Bilde]',
        audio: '[Lyd]',

        // Chat page empty state
        selectChatToStart: 'Velg en chat for å starte',
        selectFromList: 'Velg fra listen eller opprett en ny samtale',
        selectChatForDetail: 'Velg en chat for å se karakterdetaljer',

        // Toast messages
        toast: {
            noTopics: 'Ingen anbefalte emner tilgjengelig',
            getTopicsFailed: 'Kunne ikke hente anbefalte emner',
            noMessageToRefresh: 'Ingen melding å oppdatere',
            editSuccess: 'Redigering vellykket',
            editFailed: 'Redigering mislyktes',
            operationSuccess: 'Operasjon vellykket',
            operationFailed: 'Operasjon mislyktes',
            selectImageFile: 'Velg en bildefil',
            imageSizeLimit: 'Bildestørrelsen kan ikke overstige 10MB',
            uploading: 'Laster opp...',
            uploadSuccess: 'Opplasting fullført',
            uploadFailed: 'Opplasting mislyktes',
            insufficientCoins: 'Ikke nok mynter, vennligst fyll på',
            noImageToSave: 'Ingen bilde å lagre',
            noVideoToSave: 'Ingen video å lagre',
            saveSuccess: 'Lagret',
            saveFailed: 'Lagring mislyktes, prøv igjen',
            mediaLoadFailed: 'Medie kunne ikke lastes inn',
            switchSuccess: 'Byttet til',
            switchFailed: 'Klarte ikke å bytte modus',
            networkError: 'Nettverksfeil, prøv igjen',
            waitForAiReply: 'Vent på AI-svar',
            sendFailed: 'Kunne ikke sende, prøv igjen',
            regenerateFailed: 'Kunne ikke regenerere, prøv igjen',
            waitTimeout: 'Ventetid utløpt, prøv igjen',
            audioGenerateSuccess: 'Lyd generert',
            conversationNotExist: 'Samtalen finnes ikke',
            audioGenerateFailed: 'Kunne ikke generere lyd',
            mediaGenerating: 'Genererer...',
            imageGenerating: 'Genererer bilde...',
            videoGenerating: 'Genererer video...',
            mediaGenerateFailed: 'Generering mislyktes, prøv igjen',
            mediaNetworkError: 'Nettverksfeil, prøv igjen',
            heartUnlockSuccess: 'Låst opp',
            heartUnlockFailed: 'Kunne ikke låse opp',
            },
    },
    nl: {
        // Common operations
        edit: 'Bewerken',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        processing: 'Bezig...',
        saving: 'Opslaan...',
        save: 'Opslaan',

        // Message action menu
        startNewChatFromHere: 'Start nieuwe chat vanaf hier',

        // Heart related
        viewHeart: 'Bekijk hart',
        heartMoment: 'Hartmoment',
        unlocking: 'Ontgrendelen...',
        unlock: 'Ontgrendelen',

        // Voice guide
        voiceGuideText: 'Wanneer ingeschakeld worden antwoorden van het personage automatisch als audio afgespeeld.',

        // Media generation modal
        imageGeneration: 'Genereer afbeelding',
        videoGeneration: 'Genereer video',
        imageSubtitle: 'Genereer exclusieve visuals op basis van het huidige gesprek',
        videoSubtitle: 'Breng stilstaande beelden tot leven, leg vloeiende momenten vast',
        character: 'Personage',
        currentCharacter: 'Huidig personage',
        uploadYourPhoto: 'Upload je foto',
        optional: '(Optioneel)',
        imageHint: 'Je kunt een foto van jezelf uploaden, dan genereer ik een foto van ons beiden op basis van je uiterlijk. Als je niets uploadt, genereer ik een solo-foto op basis van het huidige gesprek.',
        videoHint: 'Je kunt een foto van jezelf uploaden om een duo-video met het personage te genereren. Als je niets uploadt, wordt er een solo-video van het personage gegenereerd.',
        startGenerate: 'Start genereren',

        // Media result modal
        generatingImage: 'Afbeelding genereren...',
        generatingVideo: 'Video genereren...',
        imageGeneratingSubtitle: 'Het genereren van de foto duurt even. Zodra het klaar is, stuur ik de foto direct naar onze chat. Je kunt gerust blijven chatten.',
        videoGeneratingSubtitle: 'Het genereren van de video duurt even. Zodra het klaar is, stuur ik de video direct naar onze chat. Je kunt gerust blijven chatten.',
        continueChat: 'Doorgaan met chatten',
        imageComplete: 'Generatie voltooid',
        videoComplete: 'Generatie voltooid',
        imageCompleteSubtitle: 'Dit is onze exclusieve herinnering',
        videoCompleteSubtitle: 'Dit is onze exclusieve herinnering',
        saveImage: 'Foto opslaan',
        saveVideo: 'Video opslaan',
        generateFailed: 'Genereren mislukt, probeer later opnieuw',
        gotIt: 'Begrepen',

        // Chat input
        inputPlaceholder: 'Wat wil je zeggen',

        // Edit message modal
        editMessage: 'Bericht bewerken',
        editPlaceholder: 'Voer berichtinhoud in',
        editHint: 'Tip: gebruik () om acties, uitdrukkingen of omgevingsbeschrijvingen te omsluiten',

        // Rollback confirmation modal
        rollbackTitle: 'Start nieuwe chat vanaf hier',
        rollbackMessage: 'Het starten van een chat vanaf hier verwijdert alle volgende berichten. Weet je het zeker?',

        // Mode selector
        switchChatMode: 'Wissel chatmodus',
        subscribe: 'Abonneren',
        freeUnlimitedChat: 'Gratis onbeperkt chatten',
        vipMemberBanner: 'Word VIP en geniet',
        unlimitedChat: 'Onbeperkt chatten',
        vipDescription: 'Intens & chill dubbele ervaring',
        vipDescriptionSuffix: 'VIP 0 munten onbeperkt chatten, laat je fantasie los.',
        vipFree: 'VIP gratis',
        vipOnly: 'Alleen VIP',
        perMessage: '/bericht',
        saveChanges: 'Wijzigingen opslaan',

        // Message list
        messageList: 'Berichten',
        recent: 'Recent',
        recentChats: 'Recente chats',
        loading: 'Laden...',
        noRecords: 'Geen chatgeschiedenis',
        emoji: '[Emoji]',
        image: '[Afbeelding]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Selecteer een chat om te starten',
        selectFromList: 'Kies uit de lijst of maak een nieuw gesprek',
        selectChatForDetail: 'Selecteer een chat om personagedetails te bekijken',

        // Toast messages
        toast: {
            noTopics: 'Geen aanbevolen onderwerpen beschikbaar',
            getTopicsFailed: 'Ophalen van aanbevolen onderwerpen mislukt',
            noMessageToRefresh: 'Geen bericht om te verversen',
            editSuccess: 'Bewerken gelukt',
            editFailed: 'Bewerken mislukt',
            operationSuccess: 'Bewerking geslaagd',
            operationFailed: 'Bewerking mislukt',
            selectImageFile: 'Selecteer een afbeeldingsbestand',
            imageSizeLimit: 'Afbeelding mag niet groter zijn dan 10MB',
            uploading: 'Uploaden...',
            uploadSuccess: 'Upload geslaagd',
            uploadFailed: 'Upload mislukt',
            insufficientCoins: 'Onvoldoende munten, laad op',
            noImageToSave: 'Geen afbeelding om op te slaan',
            noVideoToSave: 'Geen video om op te slaan',
            saveSuccess: 'Opgeslagen',
            saveFailed: 'Opslaan mislukt, probeer opnieuw',
            mediaLoadFailed: 'Media kon niet laden',
            switchSuccess: 'Gewisseld naar',
            switchFailed: 'Wisselen van modus mislukt',
            networkError: 'Netwerkfout, probeer opnieuw',
            waitForAiReply: 'Wacht op AI-antwoord',
            sendFailed: 'Verzenden mislukt, probeer opnieuw',
            regenerateFailed: 'Opnieuw genereren mislukt, probeer opnieuw',
            waitTimeout: 'Wacht timeout, probeer opnieuw',
            audioGenerateSuccess: 'Audio succesvol gegenereerd',
            conversationNotExist: 'Gesprek bestaat niet',
            audioGenerateFailed: 'Audio genereren mislukt',
            mediaGenerating: 'Genereren...',
            imageGenerating: 'Afbeelding genereren...',
            videoGenerating: 'Video genereren...',
            mediaGenerateFailed: 'Genereren mislukt, probeer opnieuw',
            mediaNetworkError: 'Netwerkfout, probeer opnieuw',
            heartUnlockSuccess: 'Ontgrendeld',
            heartUnlockFailed: 'Ontgrendelen mislukt',
            },
    },
    id: {
        // Common operations
        edit: 'Edit',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
        processing: 'Memproses...',
        saving: 'Menyimpan...',
        save: 'Simpan',

        // Message action menu
        startNewChatFromHere: 'Mulai chat baru dari sini',

        // Heart related
        viewHeart: 'Lihat Hati',
        heartMoment: 'Momen Hati',
        unlocking: 'Membuka kunci...',
        unlock: 'Buka kunci',

        // Voice guide
        voiceGuideText: 'Jika diaktifkan, balasan karakter akan otomatis menghasilkan pemutaran suara.',

        // Media generation modal
        imageGeneration: 'Buat Gambar',
        videoGeneration: 'Buat Video',
        imageSubtitle: 'Buat visual eksklusif berdasarkan percakapan saat ini',
        videoSubtitle: 'Hidupkan gambar diam, tangkap momen yang mengalir',
        character: 'Karakter',
        currentCharacter: 'Karakter Saat Ini',
        uploadYourPhoto: 'Unggah fotomu',
        optional: '(Opsional)',
        imageHint: 'Kamu dapat mengunggah foto dirimu, dan aku akan membuat foto kita berdua berdasarkan penampilanmu. Jika tidak diunggah, aku akan membuat foto solo berdasarkan percakapan saat ini.',
        videoHint: 'Kamu dapat mengunggah fotomu untuk membuat video duo dengan karakter. Jika tidak diunggah, akan dibuat video solo karakter.',
        startGenerate: 'Mulai Buat',

        // Media result modal
        generatingImage: 'Membuat gambar...',
        generatingVideo: 'Membuat video...',
        imageGeneratingSubtitle: 'Pembuatan foto butuh sebentar. Setelah selesai, aku akan mengirim foto langsung ke chat kita. Silakan lanjut mengobrol.',
        videoGeneratingSubtitle: 'Pembuatan video butuh sebentar. Setelah selesai, aku akan mengirim video langsung ke chat kita. Silakan lanjut mengobrol.',
        continueChat: 'Lanjut Chat',
        imageComplete: 'Pembuatan Selesai',
        videoComplete: 'Pembuatan Selesai',
        imageCompleteSubtitle: 'Ini adalah kenangan eksklusif kita',
        videoCompleteSubtitle: 'Ini adalah kenangan eksklusif kita',
        saveImage: 'Simpan Foto',
        saveVideo: 'Simpan Video',
        generateFailed: 'Pembuatan gagal, coba lagi nanti',
        gotIt: 'Mengerti',

        // Chat input
        inputPlaceholder: 'Apa yang ingin kamu katakan',

        // Edit message modal
        editMessage: 'Edit Pesan',
        editPlaceholder: 'Masukkan isi pesan',
        editHint: 'Tip: Gunakan () untuk membungkus aksi karakter, ekspresi, atau deskripsi lingkungan',

        // Rollback confirmation modal
        rollbackTitle: 'Mulai chat baru dari sini',
        rollbackMessage: 'Memulai chat dari sini akan menghapus semua pesan berikutnya. Yakin?',

        // Mode selector
        switchChatMode: 'Ganti Mode Chat',
        subscribe: 'Berlangganan',
        freeUnlimitedChat: 'Chat Gratis Tanpa Batas',
        vipMemberBanner: 'Jadi VIP dan nikmati',
        unlimitedChat: 'Chat Tanpa Batas',
        vipDescription: 'Pengalaman ganda Intens & Chill',
        vipDescriptionSuffix: 'VIP 0 koin chat tanpa batas, lepaskan semua imajinasimu.',
        vipFree: 'VIP Gratis',
        vipOnly: 'Khusus VIP',
        perMessage: '/pesan',
        saveChanges: 'Simpan Perubahan',

        // Message list
        messageList: 'Pesan',
        recent: 'Terbaru',
        recentChats: 'Chat Terbaru',
        loading: 'Memuat...',
        noRecords: 'Tidak ada riwayat chat',
        emoji: '[Emoji]',
        image: '[Gambar]',
        audio: '[Audio]',

        // Chat page empty state
        selectChatToStart: 'Pilih chat untuk mulai',
        selectFromList: 'Pilih dari daftar atau buat percakapan baru',
        selectChatForDetail: 'Pilih chat untuk melihat detail karakter',

        // Toast messages
        toast: {
            noTopics: 'Tidak ada topik yang direkomendasikan',
            getTopicsFailed: 'Gagal mengambil topik yang direkomendasikan',
            noMessageToRefresh: 'Tidak ada pesan untuk disegarkan',
            editSuccess: 'Berhasil diedit',
            editFailed: 'Edit gagal',
            operationSuccess: 'Operasi berhasil',
            operationFailed: 'Operasi gagal',
            selectImageFile: 'Pilih file gambar',
            imageSizeLimit: 'Ukuran gambar tidak boleh melebihi 10MB',
            uploading: 'Mengunggah...',
            uploadSuccess: 'Unggah berhasil',
            uploadFailed: 'Unggah gagal',
            insufficientCoins: 'Koin tidak cukup, silakan isi ulang',
            noImageToSave: 'Tidak ada gambar untuk disimpan',
            noVideoToSave: 'Tidak ada video untuk disimpan',
            saveSuccess: 'Berhasil disimpan',
            saveFailed: 'Gagal menyimpan, coba lagi',
            mediaLoadFailed: 'Media gagal dimuat',
            switchSuccess: 'Berhasil beralih ke',
            switchFailed: 'Gagal mengganti mode',
            networkError: 'Kesalahan jaringan, coba lagi',
            waitForAiReply: 'Tunggu balasan AI',
            sendFailed: 'Gagal mengirim, coba lagi',
            regenerateFailed: 'Gagal membuat ulang, coba lagi',
            waitTimeout: 'Waktu tunggu habis, coba lagi',
            audioGenerateSuccess: 'Audio berhasil dibuat',
            conversationNotExist: 'Percakapan tidak ada',
            audioGenerateFailed: 'Gagal membuat audio',
            mediaGenerating: 'Sedang dibuat...',
            imageGenerating: 'Sedang membuat gambar...',
            videoGenerating: 'Sedang membuat video...',
            mediaGenerateFailed: 'Pembuatan gagal, coba lagi',
            mediaNetworkError: 'Kesalahan jaringan, coba lagi',
            heartUnlockSuccess: 'Berhasil dibuka',
            heartUnlockFailed: 'Gagal membuka',
            },
    },
    tr: {
        // Common operations
        edit: 'Düzenle',
        cancel: 'İptal',
        confirm: 'Onayla',
        processing: 'İşleniyor...',
        saving: 'Kaydediliyor...',
        save: 'Kaydet',

        // Message action menu
        startNewChatFromHere: 'Buradan yeni sohbet başlat',

        // Heart related
        viewHeart: 'Kalbi Gör',
        heartMoment: 'Kalp Anı',
        unlocking: 'Kilit açılıyor...',
        unlock: 'Kilidi Aç',

        // Voice guide
        voiceGuideText: 'Etkinleştirildiğinde, karakter yanıtları otomatik olarak sesli oynatma oluşturur.',

        // Media generation modal
        imageGeneration: 'Görsel Oluştur',
        videoGeneration: 'Video Oluştur',
        imageSubtitle: 'Mevcut konuşmaya göre özel görseller oluştur',
        videoSubtitle: 'Durağan görüntüleri canlandır, akıcı anları yakala',
        character: 'Karakter',
        currentCharacter: 'Mevcut Karakter',
        uploadYourPhoto: 'Fotoğrafını yükle',
        optional: '(İsteğe bağlı)',
        imageHint: 'Kendi fotoğrafını yükleyebilirsin; görünümüne göre ikimizin fotoğrafını oluştururum. Yüklenmezse, mevcut konuşmaya göre tekli bir fotoğraf oluştururum.',
        videoHint: 'Kendi fotoğrafını yükleyerek karakterle bir duo video oluşturabilirsin. Yüklenmezse tekli karakter videosu oluşturulur.',
        startGenerate: 'Oluşturmayı Başlat',

        // Media result modal
        generatingImage: 'Görsel oluşturuluyor...',
        generatingVideo: 'Video oluşturuluyor...',
        imageGeneratingSubtitle: 'Görsel oluşturma biraz zaman alır. Tamamlandığında görseli doğrudan sohbete göndereceğim. Sohbete devam edebilirsin.',
        videoGeneratingSubtitle: 'Video oluşturma biraz zaman alır. Tamamlandığında videoyu doğrudan sohbete göndereceğim. Sohbete devam edebilirsin.',
        continueChat: 'Sohbete devam et',
        imageComplete: 'Oluşturma tamamlandı',
        videoComplete: 'Oluşturma tamamlandı',
        imageCompleteSubtitle: 'Bu bizim özel anımız',
        videoCompleteSubtitle: 'Bu bizim özel anımız',
        saveImage: 'Fotoğrafı Kaydet',
        saveVideo: 'Videoyu Kaydet',
        generateFailed: 'Oluşturma başarısız oldu, lütfen daha sonra tekrar deneyin',
        gotIt: 'Anladım',

        // Chat input
        inputPlaceholder: 'Ne söylemek istersin',

        // Edit message modal
        editMessage: 'Mesajı Düzenle',
        editPlaceholder: 'Mesaj içeriğini girin',
        editHint: 'İpucu: Karakter eylemlerini, ifadeleri veya ortam açıklamalarını () içine alın',

        // Rollback confirmation modal
        rollbackTitle: 'Buradan yeni sohbet başlat',
        rollbackMessage: 'Buradan sohbet başlatmak sonraki tüm mesajları siler. Emin misiniz?',

        // Mode selector
        switchChatMode: 'Sohbet Modunu Değiştir',
        subscribe: 'Abone Ol',
        freeUnlimitedChat: 'Ücretsiz sınırsız sohbet',
        vipMemberBanner: 'VIP ol ve keyfini çıkar',
        unlimitedChat: 'Sınırsız sohbet',
        vipDescription: 'Yoğun & sakin çift deneyim',
        vipDescriptionSuffix: 'VIP 0 jeton sınırsız sohbet, hayal gücünü serbest bırak.',
        vipFree: 'VIP Ücretsiz',
        vipOnly: 'Yalnızca VIP',
        perMessage: '/mesaj',
        saveChanges: 'Değişiklikleri Kaydet',

        // Message list
        messageList: 'Mesajlar',
        recent: 'Son',
        recentChats: 'Son sohbetler',
        loading: 'Yükleniyor...',
        noRecords: 'Sohbet kaydı yok',
        emoji: '[Emoji]',
        image: '[Görsel]',
        audio: '[Ses]',

        // Chat page empty state
        selectChatToStart: 'Başlamak için bir sohbet seçin',
        selectFromList: 'Listeden seçin veya yeni bir konuşma oluşturun',
        selectChatForDetail: 'Karakter ayrıntılarını görmek için bir sohbet seçin',

        // Toast messages
        toast: {
            noTopics: 'Önerilen konu yok',
            getTopicsFailed: 'Önerilen konular alınamadı',
            noMessageToRefresh: 'Yenilenecek mesaj yok',
            editSuccess: 'Düzenleme başarılı',
            editFailed: 'Düzenleme başarısız',
            operationSuccess: 'İşlem başarılı',
            operationFailed: 'İşlem başarısız',
            selectImageFile: 'Lütfen bir görsel dosyası seçin',
            imageSizeLimit: 'Görsel boyutu 10MB\'yi aşamaz',
            uploading: 'Yükleniyor...',
            uploadSuccess: 'Yükleme başarılı',
            uploadFailed: 'Yükleme başarısız',
            insufficientCoins: 'Yetersiz jeton, lütfen yükleme yapın',
            noImageToSave: 'Kaydedilecek görsel yok',
            noVideoToSave: 'Kaydedilecek video yok',
            saveSuccess: 'Kaydedildi',
            saveFailed: 'Kaydetme başarısız, lütfen tekrar deneyin',
            mediaLoadFailed: 'Medya yüklenemedi',
            switchSuccess: 'Şuna geçildi',
            switchFailed: 'Mod değiştirme başarısız',
            networkError: 'Ağ hatası, lütfen tekrar deneyin',
            waitForAiReply: 'AI yanıtı bekleniyor',
            sendFailed: 'Gönderilemedi, lütfen tekrar deneyin',
            regenerateFailed: 'Yeniden oluşturma başarısız, lütfen tekrar deneyin',
            waitTimeout: 'Bekleme zaman aşımı, lütfen tekrar deneyin',
            audioGenerateSuccess: 'Ses başarıyla oluşturuldu',
            conversationNotExist: 'Konuşma mevcut değil',
            audioGenerateFailed: 'Ses oluşturma başarısız',
            mediaGenerating: 'Oluşturuluyor...',
            imageGenerating: 'Görsel oluşturuluyor...',
            videoGenerating: 'Video oluşturuluyor...',
            mediaGenerateFailed: 'Oluşturma başarısız, lütfen tekrar deneyin',
            mediaNetworkError: 'Ağ hatası, lütfen tekrar deneyin',
            heartUnlockSuccess: 'Kilit başarıyla açıldı',
            heartUnlockFailed: 'Kilit açılamadı',
        },
    },
}
